<template>
  <el-card class="h-full" id="captureImage">
    <el-row class="h-full">
      <!-- <el-col
        :span="playerSpan"
        v-loading.lock="(fullscreenLoading && playerId) || mainFileLoading"
        class="h-full position-relative"
        :class="{ 'split-box': playerSpan === 12, 'screen-active': focusScreen === 'left' }"
        @click.native="setFocusScreen('left')"
      > -->
      <el-col
        :span="playerSpan"
        v-loading.lock="(fullscreenLoading && playerId) || mainFileLoading"
        class="h-full position-relative"
        :class="{ 'split-box': playerSpan === 12, 'screen-active': focusScreen === 'left' }"
      >
        <!-- 截图编辑时的蒙层 -->
        <edit-View
          v-if="showMainEditPhoto"
          :EditViewProps="MainEditViewProps"
          :currentBrowseFile="currentBrowseFile"
          :standardId="standardId"
          @hideEditView="hideMainEditView"
        ></edit-View>
        <!-- 截图等待时的透明图层 -->
        <div class="h-full w-full wait_layer" v-if="isShowWaitLayer"></div>
        <img
          :src="mainVersionTag === 0 ? 'static/img/gz/在用.png' : 'static/img/gz/废用.png'"
          alt
          v-if="versionManagement === 'true' && _.isNumber(mainVersionTag)"
          class="position-absolute"
          style="left: 40px; width: 160px; top: 100px"
        />
        <div class="player-box h-full" v-if="playerId">
          <video
            v-show="mainFileType.toLowerCase() === 'pr'"
            id="EngineVideo"
            autoplay
            playsinline
            muted
            class="w-full h-full"
            style="object-fit: fill"
          ></video>
          <!-- 云渲染tool栏 -->
          <div class="player-tool">
            <div class="tool-tag h-full">
              <el-tag
                v-for="tag in tags"
                :key="tag.name"
                @click="tagsClick(tag.val, tag)"
                :class="{ 'active-tab-name': activePlayerTabName === tag.name }"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="tag.name"
                  placement="top"
                  :open-delay="1000"
                >
                  <!-- <span class="iconfont" :class="tag.iconName"></span> -->
                  <img :src="tag.iconName" alt />
                </el-tooltip>
              </el-tag>
              <el-tag>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="小地图"
                  placement="top"
                  :open-delay="1000"
                >
                  <img src="../image/toolbar/smallMap1.png" @click="openMap" alt />
                </el-tooltip>
              </el-tag>
              <div class="text-color-blue ml-30px model-file-name">{{ mainScreenFileName }}</div>
            </div>
          </div>
          <!-- model tree start -->
          <model-tree
            v-if="showModelTree"
            :setSemitransparent="setSemitransparent"
            @setModelVisible="setModelVisible"
            :modelTreeProp="modelTreeProp"
            :treeData="modelTreeProp.treeData"
            @clickModelTree="clickModelTree"
            :currentNodeNameF="modelTreeProp.currentNodeName"
            :currentNodeItemF="modelTreeProp.currentNodeItem"
            :filterItem="filterItem"
            :modelHideList="modelHideList"
            :player="player"
          ></model-tree>
          <!-- model tree end -->
        </div>
        <div v-else class="w-full h-full position-relactive">
          <div
            v-if="mainScreenFileName"
            class="h-36px leading-36px text-color-black tl fileTitle-box fz-14"
            style="left: 0; right: 0"
          >
            <p class="pl-10px">{{ mainScreenFileName }}</p>
            <div class="flex special-tool" v-if="!this.$route.query.isOnlyView">
              <!-- <span v-show="mainFileType.toLowerCase() === 'pdf'" class="pr-30px text-color-blue"
                >操作提示：Ctrl + 鼠标滚轮中键 可放大缩小</span
              > -->
              <!-- <template v-if="isCanAddHot && mainFileType.toLowerCase() === 'svg'">
                <el-tooltip
                  v-if="!showHotSaveIcon"
                  content="新增标签"
                  placement="top"
                  effect="dark"
                  :open-delay="1000"
                >
                  <el-button
                    type="primary"
                    size="mini"
                    class="ml-0px mr-5px"
                    icon="el-icon-plus"
                    @click="showHotSaveIcon = true"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  v-if="showHotSaveIcon"
                  content="保存标签"
                  placement="top"
                  effect="dark"
                  :open-delay="1000"
                >
                  <el-button
                    type="primary"
                    size="mini"
                    class="ml-0px mr-5px"
                    icon="iconfont el-icon-check"
                    @click="saveHotTag"
                  ></el-button>
                </el-tooltip>
              </template> -->
              <template v-if="_.includes(modelMark, '三维标记')">
                <!-- 二维标记、三维标记 -->
                <el-tooltip content="二维标记" placement="top" effect="dark" :open-delay="1000">
                  <img
                    src="../image/toolbar/modelMark_bule.png"
                    class="mr-5px mark_btn"
                    @click="captureImage('main')"
                  />
                </el-tooltip>
              </template>
              <template v-if="_.includes(modelMark, '标记列表')">
                <el-tooltip content="标记列表" placement="top" effect="dark" :open-delay="1000">
                  <img
                    src="../image/toolbar/markList_bule.png"
                    class="mr-5px mark_btn"
                    @click="showMarkList('main')"
                  />
                </el-tooltip>
              </template>
            </div>
          </div>
          <div
            :style="{ height: type !== 'object' ? 'calc(100% - 40px)' : 'calc(100% - 30px)' }"
            v-loading="svgLoading"
            :class="{
              'bg-color-white': ['dwg', 'svg', 'dxf'].includes(mainFileType.toLowerCase()),
            }"
          >
            <!-- svg -->
            <iframe
              class="w-full h-full"
              id="mainSvgIframe"
              ref="mainSvgIframe"
              @load="mainSvgIframeLoad()"
              :src="`/lib/svgView/index.html?file=${mainResourceUrl}?fileId=${mainFileId}`"
              v-if="['dwg', 'svg', 'dxf'].includes(mainFileType.toLowerCase())"
            ></iframe>
            <!-- 文件预览 -->
            <div v-else class="w-full h-full" id="mainFileview"></div>

            <!-- 图片 -->
            <!-- <div
              id="mainImgDom"
              class="w-full h-full flex-row-center-center"
              @mousewheel="bagimg($event, 'mainImg')"
              @dblclick="imgBack('mainImg')"
              v-else-if="imgTypeList.includes(mainFileType.toLowerCase())"
            >
              <img v-move id="mainImg" :src="mainResourceUrl" />
            </div> -->
            <!-- tif -->
            <!-- <div
              id="mainImgDom"
              class="w-full h-full flex-row-center-center"
              @mousewheel="bagimg($event, 'mainImg')"
              @dblclick="imgBack('mainImg')"
              v-else-if="mainFileType.toLowerCase() === 'tif'"
              v-loading="loadingTif"
            >
              <img v-move id="mainImg" :src="tifUrl" />
            </div> -->
            <!-- pdf -->
            <!-- <iframe
              :src="`/lib/pdfjs/web/viewer.html?file=${mainResourceUrl}#${fileLocationByComponent}`"
              id="mainPdfIframe"
              @load="mainFileLoading = false"
              v-else-if="mainFileType.toLowerCase() === 'pdf'"
              class="w-full h-full"
            ></iframe>
            <iframe
              v-else-if="mainFileType.toLowerCase() === 'wizdrawing'"
              @load="mainFileLoading = false"
              ref="leftHtFrame"
              :src="htPage"
              class="h-full w-full"
            ></iframe> -->
            <!-- 其他的文件类型 -->
            <!-- <iframe
              v-else-if="
                mainFileType &&
                mainFileType.toLowerCase() !== 'mp4' &&
                mainFileType.toLowerCase() !== 'pr'
              "
              :src="mainResourceUrl"
              class="h-full w-full"
              @load="mainFileLoading = false"
            ></iframe> -->
            <!-- 视频 -->
            <!-- <div
              v-if="!videoError && mainFileType.toLowerCase() === 'mp4'"
              class="show-video w-full h-full"
            >
              <video
                :src="mainResourceUrl"
                class="w-full h-full"
                id="video"
                controls
                ref="videoPlayer"
              ></video>
            </div> -->
            <!-- <div class="tc p-10 c-g9" v-if="videoError">视频播放出现错误</div> -->
          </div>
          <el-tooltip content="上一个文件" placement="top" :open-delay="1000" effect="dark">
            <!-- content to trigger tooltip here -->
            <span
              class="position-absolute last_file_btn text-16px iconfont icon-pc-back"
              @click="changeFile('back', 'main')"
            ></span>
          </el-tooltip>
          <el-tooltip content="下一个文件" placement="top" :open-delay="1000" effect="dark">
            <!-- content to trigger tooltip here -->
            <span
              class="position-absolute next_file_btn text-16px iconfont icon-pc-next"
              @click="changeFile('next', 'main')"
            ></span>
          </el-tooltip>
          <!-- 实体文档模块，浏览文档才展示关闭按钮 -->
          <!-- <div class="text-center h-36px mb-10px" v-if="type !== 'object'">
            <el-button size="small" @click.stop="closeDocument">关闭</el-button>
          </div> -->
        </div>
      </el-col>
      <!-- 分屏右侧展示 -->
      <el-col v-loading="fileLoading" :span="24 - playerSpan" class="h-full position-relative">
        <!-- 截图编辑时的蒙层 -->
        <edit-View
          v-if="showSplitEditPhoto"
          :EditViewProps="SplitEditViewProps"
          @hideEditView="hideSplitEditView"
        ></edit-View>
        <!-- 截图等待时的透明图层 -->
        <div class="h-full w-full wait_layer position-relactive" v-if="isShowWaitLayer"></div>
        <img
          :src="fileVersionTag === 0 ? 'static/img/gz/在用.png' : 'static/img/gz/废用.png'"
          alt
          v-if="versionManagement === 'true' && _.isNumber(fileVersionTag)"
          class="position-absolute"
          style="left: 40px; top: 100px; width: 160px"
        />
        <div class="h-36px leading-36px text-color-black tl fileTitle-box fz-14">
          <p class="pl-10px">{{ splitScreenFileName }}</p>
          <div class="flex special-tool" v-if="!this.$route.query.isOnlyView">
            <!-- <span
              v-show="fileType.toLowerCase() === 'pdf'"
              class="text-color-blue"
              :class="modelMark === '1' ? 'pr-5px ' : 'pr-30px'"
              >操作提示：Ctrl + 鼠标滚轮中键 可放大缩小</span
            > -->

            <template v-if="_.includes(modelMark, '三维标记')">
              <!-- 二维标记、三维标记 -->
              <el-tooltip content="二维标记" placement="top" effect="dark" :open-delay="1000">
                <img
                  src="../image/toolbar/modelMark_bule.png"
                  class="mr-5px mark_btn"
                  @click="captureImage('split')"
                />
              </el-tooltip>
            </template>
            <template v-if="_.includes(modelMark, '标记列表')">
              <el-tooltip content="标记列表" placement="top" effect="dark" :open-delay="1000">
                <img
                  src="../image/toolbar/markList_bule.png"
                  class="mr-30px mark_btn"
                  @click="showMarkList('split')"
                />
              </el-tooltip>
            </template>
          </div>
        </div>
        <div
          class="w-full h-[calc(100%-36px)]"
          :class="{ 'bg-color-white': fileType.toLowerCase() === 'svg' }"
          :style="
            fileType.toLowerCase() === 'pr'
              ? 'background:rgba(74, 160, 255, 0.5); padding: 0px'
              : 'padding: 0px'
          "
        >
          <!-- svg预览 -->
          <iframe
            v-if="fileType.toLowerCase() === 'svg'"
            class="w-full h-full"
            :src="`/lib/svgView/index.html?file=${drawUrl}?fileId=${fileId}`"
            @load="loadSplitSvg()"
            id="svgIframe"
            ref="svgIframe"
          ></iframe>
          <!-- pr预览 -->
          <iframe
            v-else-if="fileType.toLowerCase() === 'pr'"
            :src="drawUrl"
            width="100%"
            height="100%"
            class="w-full h-full"
            allowfullscreen
          ></iframe>
          <!-- 文件预览 -->
          <div v-else class="w-full h-full" id="splitFileview"></div>

          <!-- 图片 -->
          <!-- <div
            id="splitImgDom"
            class="w-full h-full flex-row-center-center"
            @mousewheel="bagimg($event, 'splitImg')"
            @dblclick="imgBack('splitImg')"
            v-else-if="imgTypeList.includes(fileType.toLowerCase())"
          >
            <img v-move :src="drawUrl" id="splitImg" />
          </div> -->
          <!-- pdf -->
          <!-- <iframe
            :src="`/lib/pdfjs/web/viewer.html?file=${drawUrl}`"
            id="splitPdfIframe"
            v-else-if="fileType.toLowerCase() === 'pdf'"
            class="w-full h-full"
            @load="loadSplitOther()"
          ></iframe>
          <iframe
            v-else-if="fileType.toLowerCase() === 'wizdrawing'"
            ref="rightHtFrame"
            :src="htPage"
            class="w-full h-full"
          ></iframe> -->
          <!-- 其他的文件类型 -->
          <!-- <iframe
            v-else-if="
              fileType && fileType.toLowerCase() !== 'mp4' && fileType.toLowerCase() !== 'pr'
            "
            :src="`${drawUrl}/${fileId}`"
            @load="loadSplitOther()"
            class="h-full w-full"
          ></iframe> -->
          <!-- <div class="player-box h-full" v-if="splitScreenPlayerId">
            <video
              id="splitScreenEngineVideo"
              autoplay
              playsinline
              muted
              class="w-full h-full"
              style="object-fit: fill"
            ></video> -->
          <!-- 云渲染tool栏 -->
          <!-- <div class="player-tool">
              <div class="tool-tag h-full">
                <el-tag
                  v-for="tag in tags"
                  :key="tag.name"
                  @click="tagsClick(tag.val, tag)"
                  :class="{ 'active-tab-name': activePlayerTabName === tag.name }"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="tag.name"
                    placement="top"
                    :open-delay="1000"
                  >
                    <span class="iconfont" :class="tag.iconName"></span>
                    <img :src="tag.iconName" alt />
                  </el-tooltip>
                </el-tag>
                <div class="text-color-blue ml-30px">{{ splitScreenFileName }}</div>
              </div>
            </div> -->
          <!-- </div> -->
        </div>
        <el-tooltip content="上一个文件" placement="top" effect="dark">
          <!-- content to trigger tooltip here -->
          <span
            class="position-absolute last_file_btn text-16px iconfont icon-pc-back"
            @click="changeFile('back', 'split')"
          ></span>
        </el-tooltip>
        <el-tooltip content="下一个文件" placement="top" :open-delay="1000" effect="dark">
          <!-- content to trigger tooltip here -->
          <span
            class="position-absolute next_file_btn text-16px iconfont icon-pc-next"
            @click="changeFile('next', 'split')"
          ></span>
        </el-tooltip>
      </el-col>
    </el-row>
    <!-- 模型加载进度条 -->
    <player-progress
      :percentage="loadPercentage"
      v-if="showLoadProgress"
      :loadPercentageText="loadPercentageText"
    ></player-progress>
    <!-- 下载模型进度条 -->
    <div class="propress-bar" v-if="showProgress">
      <el-progress :percentage="percentage" style="width: 80vw" :stroke-width="10"></el-progress>
    </div>
    <!-- 新增/修改svg标签弹框 -->
    <!-- <el-popover
      ref="myPopover"
      :value="showPopover"
      placement="bottom"
      width="300px"
      trigger="manual"
      @show="openPopover"
      @hide="closePopover"
    >
      <el-input />
    </el-popover> -->
  </el-card>
</template>

<script>
import { videoPlayer } from 'vue-video-player'
import Tiff from 'tiff.js'
import DocumentService from '@/services/DocumentService'
import playerProgress from '@/components/model/PlayerProgress'
import DocumentManagementService from '@/services/documentManagement'
import PreferenceSettings from '@/services/preferenceSetting'
import { cilpSetting, cancelClip } from '../js/clip'

const EditView = () => {
  return import('./photoEdit/EditView')
}
const ModelTree = () => {
  return import('./ModelTree')
}
export default {
  name: 'fileView',
  mixins: [],
  props: ['setSemitransparent', 'isCanAddHot', 'currentBrowseFile', 'standardId', 'type'],
  components: {
    videoPlayer,
    playerProgress,
    EditView,
    ModelTree,
  },
  watch: {
    /**
     * @description: 模型加载完后调用,防止code变化阻断模型移动到默认视角
     * @param {*} bol
     * @return {*}
     */
    showLoadProgress(bol) {
      if (!bol) {
        this.modelMove = false
        setTimeout(() => {
          this.modelMove = true
          this.code ? this.moveCameraByCode(this.code) : ''
        }, 3000)
      }
    },
    // 主文件类型
    mainFileType(type) {
      if (type.toLowerCase() === 'svg') {
        this.mainFileLoading = true
      }
      window.mainFileType = type.toLowerCase()
      // 启动文件预览服务
      if (!['svg', 'pr'].includes(type.toLowerCase())) {
        const fileNameType = type.toLowerCase()
        const previewUrl = `${this.filePreviewServer}/#/file-preview?url=${this.standardServer}/api/std/file/kkfileview/${this.defaultFileId}.${fileNameType}&type=${fileNameType}&name=resource.${fileNameType}`
        console.log(previewUrl, '|||||||||', this.mainResourceUrl, 'HHHHHHH')
        window.wujie.setupApp({
          name: 'mainFileviewEl', // 启动kkfileview微服务的名称
          // url: this.mainResourceUrl, // 文件地址
          url: previewUrl, // 文件地址
          el: '#mainFileview', // 文件挂载的dom元素
        })
        window.wujie.startApp({ name: 'mainFileviewEl' })
      }
    },
    // 分屏文件类型
    fileType(type) {
      if (type.toLowerCase() === 'svg') {
        this.fileLoading = true
      }
      window.fileType = type.toLowerCase()
    },
    highlightData: {
      async handler(val, oldVal) {
        this.startDay = !_.isEmpty(oldVal) ? oldVal.day : 0
        this.processMap = new Map()
        // 判断是否倒放
        if (this.startDay <= val.day) {
          // 正向播放时
          this.getChangedList(this.startDay, val.day, val.data)
          this.processMap = _.cloneDeep(this.changeProcessMap)
        } else {
          this.resetProgress()
          // 倒放时
          const oldStatus = _.cloneDeep(this.changeProcessMap)
          this.getChangedList(0, val.day, val.data)
          this.processMap = Object.assign(this.changeProcessMap)
          if (!_.isNil(oldStatus)) {
            for (const item of oldStatus.entries()) {
              const k = item[0]
              const v = item[1]
              const temp = this.processMap.get(k)
              if (temp === v) {
                this.processMap.delete(k)
              }
            }
          }
        }
        // 模型变化颜色
        if (this.flag) {
          this.sumbitEngineChanges(this.processMap)
        }
      },
      deep: true,
      immediate: true,
    },
    // splitScreenPlayerId(id) {
    //   if (id) {
    //     this.$nextTick(() => {
    //       this.runPlayer('splitScreenEngineVideo')
    //     })
    //   }
    // },
    // 分屏文件地址
    drawUrl(url) {
      console.log(url, 'url')
      if (!url) return
      if (this.fileType.toLowerCase() === 'svg') {
        window.svgIframeId = 'svgIframe'
        window.svgFileId = this.fileId
        this.drawUrl = `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${this.fileId}`
      }
      if (this.fileType.toLowerCase() === 'wizdrawing') {
        this.htLoad(url, 'right')
      }

      if (!['svg', 'pr'].includes(this.fileType.toLowerCase())) {
        window.wujie.setupApp({
          name: 'splitFileviewEl', // 启动kkfileview微服务的名称
          url: this.drawUrl, // 文件地址
          el: '#splitFileview', // 文件挂载的dom元素
        })
        window.wujie.startApp({ name: 'splitFileviewEl' })
      }
      // if (this.imgTypeList.includes(this.fileType.toLowerCase())) {
      //   return
      // }
      // this.fileLoading = true
    },
    // 主文件地址
    mainResourceUrl(url) {
      if (!url) {
        return
      }
      if (this.mainFileType.toLowerCase() === 'mp4') {
        this.videoError = false
        this.playerOptions.sources[0].src = url
      }
      if (this.mainFileType.toLowerCase() === 'wizdrawing') {
        this.htLoad(url, 'left')
      }
      if (this.mainFileType.toLowerCase() === 'tif') {
        this.tifToImg(url)
      }
    },
    // 监听页面主屏的变化
    playerSpan(val) {
      if (val === 12 && this.mainFileType.toLowerCase() === 'svg') {
        // 重新加载左侧 SVG iframe
        this.svgLoading = true
        this.$refs.mainSvgIframe.contentWindow.location.reload()
        this.svgLoading = false
        // 重新加载后激活之前热点
        setTimeout(() => {
          if (window.svgData[window.location.href] && window.currentTagCode) {
            window.svgData[window.location.href].svgHotTrigger(window.currentTagCode)
          }
        }, 1000)
      }
      if (this.fileType.toLowerCase() === 'wizdrawing') {
        this.htLoad(this.drawUrl, 'right')
      }
      if (this.mainFileType.toLowerCase() === 'wizdrawing') {
        this.htLoad(this.mainResourceUrl, 'left')
      }
    },
    playerId(id) {
      if (id) {
        this.$nextTick(async () => {
          this.loadModel = false
          this.$emit('loaded', false)
          // 判断当前是否已经加载过模型
          if (!_.isEmpty(this.player)) {
            if (this.addModelOrNode === -1) {
              // 卸载模型
              const models = await this.player.Native.Model.getAllInfo()
              _.forEach(Object.keys(models), (model) => {
                this.player.Native.Model.unloadModel(model)
              })
            } else {
              await this.player.Native.NodeProxy.destroyNode(this.modelTreeProp.treeData[0].nodePtr)
              this.modelTreeProp.treeData = []
            }
            this.player.Native.Model.EventProgress.connect(this.checkModelLoad)
            this.player.Native.Model.EventProgressEnd.connect(this.checkModelLoadEnd)
            this.checkModel()
            return
          }
          this.runPlayer('EngineVideo')
        })
      }
    },
    code(code) {
      if (code) {
        // 设置svg图片对应高亮
        if (this.fileType.toLowerCase() === 'svg' || this.mainFileType.toLowerCase() === 'svg') {
          if (window.svgData[window.location.href].svgHotTrigger) {
            window.svgData[window.location.href].svgHotTrigger(code)
          }
        }
        if (this.player && this.modelMove) {
          this.$nextTick(() => {
            this.moveCameraByCode(this.code)
          })
        }
      }
    },
    currentNodeName(val) {
      if (val) {
        this.filterModelTree(0, true, val, 3)
      }
    },
    async loadModel(val) {
      if (val) {
        // 电缆
        if (this.$route.query.type === 'cabel') {
          // 等待模型加载完后相机移动完成
          if (this.cableInfo !== '') {
            setTimeout(() => {
              this.cableImgId = null
              this.sMarkedId = null
              this.eMarkedId = null
              this.taryLineId = null
              // 绘制面板
              this.startDrawPanel(this.cableInfo)
              // 描线
              this.startDrawLine(this.cableInfo)
            }, 2000)
          }
          this.$emit('loaded', true)
        }
        // 碰撞
        if (this.clashInfo) {
          this.startDrawPoint(this.clashInfo)
        }
        // 进度
        if (this.leftCom === 'process') {
          // 切换视角，变化颜色
          // 进度模拟下拉框激活态
          this.moveCameraByVector(this.progressLocation)
          this.resetProgress()
        }
        await this.getCodeByItem()
        if (this.leftCom === 'process') {
          this.$emit('setProcessStauts', true)
        }
        this.$emit('loaded', true)
      }
    },
    modelLocationByComponent(val) {
      if (this.player && this.modelMove) {
        this.$nextTick(() => {
          this.moveCameraByVector(val)
        })
      }
    },
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      const routerBase = _.get(Wiz, 'globalSettings.globalConfig.routerBase')
      if (!routerBase) {
        return ''
        // eslint-disable-next-line no-else-return
      } else if (routerBase && Array.isArray(routerBase)) {
        return routerBase.length ? `/${routerBase[0]}` : ''
      }
      return `/${routerBase}`
    },
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    fullToken() {
      return localStorage.getItem('localforage/fullToken')
    },
    globalMapPath() {
      // 地图路径
      const obj = _.find(this.systemParams, { parameterCode: 'globalMapPath' })
      return obj ? obj.parameterValue : ''
    },
    cloundProtocol() {
      // 云渲染协议
      const obj = _.find(this.systemParams, { parameterCode: 'cloundProtocol' })
      return obj ? obj.parameterValue : ''
    },
    cloundServerPath() {
      // 云渲染服务路径
      const obj = _.find(this.systemParams, { parameterCode: 'cloundServerPath' })
      return obj ? obj.parameterValue : ''
    },
    pixelCullingThres() {
      const obj = _.find(this.systemParams, { parameterCode: 'pixelCullingThres' })
      return obj ? obj.parameterValue * 1 : 5
    },
    playerServer() {
      const playerServer = _.find(this.systemParams, { parameterCode: 'playerServer' })
      return playerServer ? playerServer.parameterValue : null
    },
    playerServerProtocol() {
      const playerServerPro = _.find(this.systemParams, { parameterCode: 'playerServerProtocol' })
      return playerServerPro ? playerServerPro.parameterValue : null
    },
    playerBtnVisible() {
      const playerOption = _.find(this.systemParams, { parameterCode: 'wizplayerButtonVisible' })
      return playerOption ? JSON.parse(playerOption.parameterValue) : {}
    },
    colorCollection() {
      // 施工进度颜色
      const color = _.find(this.systemParams, { parameterCode: 'PLAYER_COLOR_COLLECTION' })
      return color ? color.parameterValue : null
    },
    progressLocation() {
      // 施工进度默认视角
      const location = _.find(this.systemParams, { parameterCode: 'PLAYER_PROGRESS_LOCATION' })
      return location ? location.parameterValue : null
    },
    modelLocation() {
      // 模型默认视角
      const location = _.find(this.systemParams, { parameterCode: 'PLAYER_MODEL_LOCATION' })
      return location ? location.parameterValue : null
    },
    modelMark() {
      const modelTool = _.find(this.systemParams, { parameterCode: 'modelTool' }) || {}
      if (!_.isEmpty(modelTool.parameterValue)) {
        const barList = modelTool.parameterValue.split(',')
        return barList
      }
      return []
    },
    versionManagement() {
      const version = _.find(this.systemParams, { parameterCode: 'versionManagement' }) || {}
      return version.parameterValue
    },
    addModelOrNode() {
      // 加载模型或加载节点 -1为加载模型
      return this.$route.name.indexOf('3DModelRepairTrain')
    },
    defaultFileId() {
      return this.$route.query.defaultFileId
    },
    // 文件服务地址
    standardServer() {
      return Wiz.GetModuleConfig('legacy-resource')?.currentEnv?.VUE_APP_STANDARD_SERVER
    },
    // 文件预览服务地址
    filePreviewServer() {
      return Wiz.GetModuleConfig('legacy-resource')?.currentEnv?.VUE_APP_FILE_PREVIEW_SERVER
    },
  },
  data() {
    return {
      showPopover: false,
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      systemParams: localStorage.getItem('systemParams')
        ? JSON.parse(localStorage.getItem('systemParams'))
        : [],
      userPreferenceSettings: {}, // 用户偏好设置
      defaultSettings: {}, // player默认设置
      fileList: {}, // 文件列表
      showHotSaveIcon: false, // 是否显示保存活化热点的图标
      mainSvgIframeUrl: '',
      isShowWaitLayer: false, // 截图时的等待图层
      imgViewParams: {
        zoomVal: 1,
      }, // 图片缩放参数
      modelMove: true, // 模型是否移动完成
      imgTypeList: ['bmp', 'jpg', 'png', 'gif', 'webp'],
      showMainEditPhoto: false, // 是否显示截图蒙层
      showSplitEditPhoto: false, // 分屏是否显示截图蒙层
      currentFileId: '', // 当前的fileId
      temporaryFileId: '', // 临时截图部分用的fileid
      MainEditViewProps: {
        imgUrl: '',
        fileLocation: '',
        fileId: '',
        markType: '',
      }, // 截图编辑需要的信息
      modelTreeProp: {
        currentNodeItem: 0, // 当前激活的node
        currentNodeName: '', // 点选时当前激活的节点名称
        treeData: [], // 模型树数据
        defaultCheckedKey: [],
      },
      modelTreeObj: {
        ITEM_PR: 0, // PR 文件节点类型
        ITEM_NODE: 1, // CELLNode文件节点类型
        ITEM_GISOBJ: 2, // gis 数据对象
        ITEM_NULL: 3, // 仅仅对根节点使用
      },
      SplitEditViewProps: {
        imgUrl: '',
        fileLocation: '',
        fileId: '',
        markType: '',
      },
      fileLocation: '', // 文件当前位置
      modelLocationByComponent: '', // 模型加载完成时组件需要定位的位置
      fileLocationByComponent: 'page=1&zoom=auto', // pdf加载完成时需要定位的位置
      filterSelfId: [], // 模型树不需要显示的节点及他的父节点列表
      axisObjs: [], // 剖切轴对象
      clipObj: {}, // 全局剖切对象
      loadPercentage: 0, // 模型加载进度
      showLoadProgress: false,
      loadPercentageText: '',
      mainFileLoading: false,
      clickModels: [],
      isDisableTool: false,
      allTagData: [],
      planCodeUnit: [],
      progressCodeByItem: {},
      highlightColorData: null, // 进度模拟颜色
      highlightData: {},
      videoError: false, // 视频播放出错
      playerOptions: {
        // 视频播放参数配置
        height: '700',
        muted: false,
        preload: 'auto',
        language: 'zh-CN',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        aspectRatio: '16:9',
        sources: [
          {
            type: 'video/mp4',
            src: '',
          },
        ],
        fluid: true,
        poster: '',
      },
      currentModelTree: null, // 当前选中的模型树节点
      filterTreeKeyWords: '', // 过滤模型树关键字
      showModelTree: false,
      modelTreeVisbile: true, // 模型切换显示，刷新checkbox
      treeProps: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
      },
      splitScreenPlayerId: '', // 分屏模型id
      splitFilePrId: '', // 分屏模型fileId
      mainScreenFileName: '', // 主屏文件名称
      splitScreenFileName: '', // 分屏文件名称
      activePlayerTabName: '', // player面板当前激活名称
      fileLoading: false,
      treeData: [], // 模型树
      svgLoading: false, // 加载svgLoading
      fullscreenLoading: true, // 加载状态
      playerSpan: 24, // 当前主页面的比列
      mainResourceUrl: '', // 主页的地址
      mainFileType: '', // 主页的类型
      mainVersionTag: '', // 主页的文件版本状态
      mainDocumentId: '', // 主页的文档id
      mainFileId: '', // 主页的文件id
      mainFlag: '', // 主页的移交状态
      fileFlag: '', // 从页面的移交状态
      fileType: '', // 从页面的文件类型
      fileVersionTag: '', // 从页面的文件版本状态
      fileDocumentId: '', // 从页面的文档id
      fileId: '', // 从页面的文件id
      markList: [],
      drawUrl: '', // 从页的地址
      wizplayerOption: null,
      player: null,
      playerId: '', // 模型md5
      demPlayerId: '', // 模型附件md5
      cableImgId: '', // 面板背景图id
      showProgress: false,
      code: '',
      cableInfo: '', // 电缆信息
      sMarkedId: '', // 起点部件面板id
      eMarkedId: '', // 终点部件面板id
      clashInfo: '', // 碰撞信息
      modelHideList: [], // 模型隐藏队列
      spaceSwapStatus: false, // 交换空间状态
      hiddenNodeKeys: [], // 模型树隐藏显示的selfid
      centerCode: '',
      tags: [
        {
          name: '模型树',
          val: 'modelTree',
          iconName: require('../image/toolbar/tree_nor.png'),
        },
        {
          name: '点选',
          val: 'system.Pickup',
          iconName: require('../image/toolbar/picked_nor.png'),
        },
        {
          name: '移动',
          val: 'system.Move',
          iconName: require('../image/toolbar/translate_nor.png'),
        },
        {
          name: '旋转',
          val: 'system.Rotate',
          iconName: require('../image/toolbar/rotate_nor.png'),
        },
        {
          name: '隐藏',
          val: 'system.ToolHideModel',
          iconName: require('../image/toolbar/hidden_nor.png'),
        },
        { name: '缩放', val: 'system.Scale', iconName: require('../image/toolbar/zoom_nor.png') },
        {
          name: '显示',
          val: 'system.ToolShowModel',
          iconName: require('../image/toolbar/showlast_nor.png'),
        },
        {
          name: '居中',
          val: 'system.PickupCenter',
          iconName: require('../image/toolbar/center_nor.png'),
        },
        {
          name: '驻点观察',
          val: 'system.ToolFixedObservation',
          iconName: require('../image/toolbar/site_nor.png'),
        },
        {
          name: '空间交换',
          val: 'system.ToolHideModelSpaceSwap',
          iconName: require('../image/toolbar/switchshow_nor.png'),
        },
        {
          name: '显示所有已隐藏',
          val: 'system.ToolShowAll',
          iconName: require('../image/toolbar/showall_nor.png'),
        },
        {
          name: '还原初始视角',
          val: 'system.HomePoint',
          iconName: require('../image/toolbar/p2p_nor.png'),
        },
        // 模型测量
        {
          name: '两点测量',
          val: 'M_Line',
          iconName: require('../image/toolbar/toolMLine_nor.png'),
        },
        {
          name: '多点测量',
          val: 'M_Point',
          iconName: require('../image/toolbar/toolMPoint_nor.png'),
        },
        {
          name: '高度测量',
          val: 'M_Vertical',
          iconName: require('../image/toolbar/toolVertical_nor.png'),
        },
        {
          name: '立体测量',
          val: 'M_Stereo',
          iconName: require('../image/toolbar/toolp2p_nor.png'),
        },
        {
          name: '角度测量',
          val: 'M_Angel',
          iconName: require('../image/toolbar/toolAngle_nor.png'),
        },
        {
          name: '面积测量',
          val: 'M_Area',
          iconName: require('../image/toolbar/toolArea_nor.png'),
        },
        {
          name: '轴距测量',
          val: 'M_WheelBase',
          iconName: require('../image/toolbar/toolWheelBase_nor.png'),
        },
        {
          name: '清除测量结果',
          val: 'M_None',
          iconName: require('../image/toolbar/del_nor.png'),
        },
        {
          name: '材质编辑',
          val: 'system.editTexture',
          iconName: require('../image/toolbar/eidtModel_nor.png'),
        },
        {
          name: '模型透明度',
          val: 'system.transparencySetting',
          iconName: require('../image/toolbar/modelTransparence_nor.png'),
        },
      ],
      // 业务的tags,系统参数中可以配置tag的name
      businessTags: [
        {
          name: '电缆',
          val: 'system.cable',
          iconName: require('../image/toolbar/cable_nor.png'),
        },
        {
          name: '碰撞',
          val: 'system.clash',
          iconName: require('../image/toolbar/clash_nor.png'),
        },
        {
          name: '进度',
          val: 'system.process',
          iconName: require('../image/toolbar/process_nor.png'),
        },
        {
          name: '三维标记',
          val: 'system.mark',
          iconName: require('../image/toolbar/modelMark_nor.png'),
        },
        {
          name: '标记列表',
          val: 'system.markList',
          iconName: require('../image/toolbar/markList_nor.png'),
        },
        {
          name: '跟随漫游',
          val: 'system.walk.fixView',
          iconName: require('../image/toolbar/fixView_nor.png'),
        },
        {
          name: '预设路径漫游',
          val: 'system.roamPathList',
          iconName: require('../image/toolbar/roamPath_nor.png'),
        },
        {
          name: '测点历史数据',
          val: 'system.measurePoint',
          iconName: require('../image/toolbar/label_nor.png'),
        },
        {
          name: '关联测点信息',
          val: 'system.bindMeasurePoint',
          iconName: require('../image/toolbar/chargedEquipment_nor.png'),
        },
        {
          name: '组态管理',
          val: 'system.configureManage',
          iconName: require('../image/toolbar/configure_nor.png'),
        },
        {
          name: '摄像头列表',
          val: 'system.monitorList',
          iconName: require('../image/toolbar/monitor_nor.png'),
        },
        {
          name: '人员定位',
          val: 'system.personnelPositioning',
          iconName: require('../image/toolbar/position_nor.png'),
        },
        {
          name: '电子围栏',
          val: 'system.fenceDataList',
          iconName: require('../image/toolbar/fence_nor.png'),
        },
        {
          name: '设备信息',
          val: 'system.equipmentInfo',
          iconName: require('../image/toolbar/measureInfo_nor.png'),
        },
        {
          name: '设备报警信息',
          val: 'system.alarmInfo',
          iconName: require('../image/toolbar/alarm_nor.png'),
        },
      ],
      percentage: 0,
      moveFace: true, // 移动相机时是否改变视角
      loadModel: false, // 判断模型是否加载完成
      activePickup: false,
      leftCom: '', // 当前左侧组件
      isLazy: true, // 模型树是否懒加载
      currentTree: [], // 当前模型树
      taryLineId: '', // 电缆线id
      currentNode: null, // 查询到模型树节点
      startDay: 0,
      changeProcessMap: null, // 进度模拟变化的map
      processMap: null, // 进度模拟实际需要变化的map
      showTab: false,
      /**
       * 进度模拟中特殊的几个list
       */
      processList: ['advance', 'milestonLag', 'otherLag', 'currentFinish'],
      codeList: [], // 存储多个code,用于移动相机时定位
      htPage: `${window.location.origin}/static/ht/htView.html`, // ht预览页面路径
      htTimer: null,
      focusScreen: 'left', // 当前选中的分屏框
      filterItem: [], // 模型树不需要显示的节点及他的父节点列表
      flag: true,
      documentId: null, // 文档id
      loadingTif: false,
      tifUrl: '',
    }
  },
  created() {
    // this.getFileIdByDocumentId()
    this.highlightColorData = JSON.parse(this.colorCollection)
    const modelTool = _.find(this.systemParams, { parameterCode: 'modelTool' }) || {}
    if (!_.isEmpty(modelTool.parameterValue) && this.$route.name.indexOf('docView') !== -1) {
      const barList = modelTool.parameterValue.split(',')
      const tagList = _.filter(this.businessTags, (tag) => {
        return _.indexOf(barList, tag.name) !== -1
      })
      this.tags = [...this.tags, ...tagList]
      if (_.indexOf(barList, '进度') !== -1) {
        // 处理颜色格式
        // eslint-disable-next-line no-restricted-syntax
        for (const key in this.highlightColorData) {
          if (!_.isEmpty(this.highlightColorData[key])) {
            this.highlightColorData[key] = this.highlightColorData[key].replace('#', '0x')
            // 透明度添加 未施工透明度不一致
            if (key === 'notStart' || key === 'norMalNonConstruction') {
              this.highlightColorData[key] += '20'
            } else {
              this.highlightColorData[key] += 'ff'
            }
            this.highlightColorData[key] = Number(this.highlightColorData[key])
          }
        }
      }
    }
    this.findFileList(this.mainDocumentId)
    this.findFileList(this.fileDocumentId)
  },
  beforeDestroy() {
    if (this.htTimer) {
      clearInterval(this.htTimer)
    }
    if (this.player) {
      this.player.exit()
    }
  },
  methods: {
    closeDocument() {
      this.$router.push({
        path: `${this.basePath}/legacy-resource/data-collection-manage/document`,
      })
    },
    tifToImg(path) {
      this.loadingTif = true
      const xhr = new XMLHttpRequest()
      xhr.responseType = 'arraybuffer'
      xhr.open('GET', path)
      xhr.onload = () => {
        Tiff.initialize({
          TOTAL_MEMORY: 200000000,
        })
        const tiff = new Tiff({ buffer: xhr.response })
        this.tifUrl = tiff.toDataURL()
      }
      xhr.send()
      this.loadingTif = false
    },
    saveHotTag() {
      this.showHotSaveIcon = false
      this.$emit('saveHotTag')
    },
    mainSvgIframeLoad() {
      setTimeout(() => {
        window.svgData[window.location.href].svgHotTrigger(this.code)
      }, 1000)
      this.mainFileLoading = false
      this.$refs.mainSvgIframe.contentWindow.svgFileId = this.mainFileId
      this.$refs.mainSvgIframe.contentWindow.svgIframeId = 'mainSvgIframe'
    },
    // 图片滚轮缩放
    bagimg(event, typeName) {
      const e = document.getElementById(typeName)
      this.imgViewParams.zoomVal += event.wheelDelta / 1200
      if (this.imgViewParams.zoomVal >= 0.2) {
        e.style.transform = `scale(${this.imgViewParams.zoomVal})`
      } else {
        this.imgViewParams.zoomVal = 0.2
        e.style.transform = `scale(${this.imgViewParams.zoomVal})`
        return false
      }
    },
    // 双击图片缩放恢复
    imgBack(typeName) {
      const e = document.getElementById(typeName)
      this.imgViewParams.zoomVal = 1
      e.style.transform = `scale(${this.imgViewParams.zoomVal})`
      e.style.left = `${45}%`
      e.style.top = 0
    },
    // 获取截图后的快照
    getConvertToImage(container, options = {}) {
      const width = parseInt(window.getComputedStyle(container).width)
      const height = parseInt(window.getComputedStyle(container).height)
      // html2canvas配置项
      const ops = {
        width,
        height,
        useCORS: true,
        allowTaint: false,
        ...options,
        dpi: 300,
      }
      return html2canvas(container, ops).then((canvas) => {
        this.isShowWaitLayer = false // 关闭等待图层
        return canvas.toDataURL('image/png')
      })
    },
    // 根据documentid获取到fileId
    async getFileIdByDocumentId() {
      const res = await DocumentManagementService.getDocumentEdite({
        id: this.$route.query.documentId,
      })
      if (res && res.code === 0 && res.data) {
        this.temporaryFileId = res.data.documentBaseInfo
          ? res.data.documentBaseInfo.defaultFileId
          : ''
      }
    },
    /**
     * @description: 截图
     * @param {*} captureScreen 截图所在的屏
     * @return {*}
     */

    async captureImage(captureScreen) {
      if (captureScreen === 'pr') {
        captureScreen = this.splitFilePrId ? 'split' : 'main'
      }
      let fileId = captureScreen === 'main' ? this.mainFileId : this.fileId
      const fileType =
        captureScreen === 'main' ? this.mainFileType.toLowerCase() : this.fileType.toLowerCase()
      const markType = fileType === 'pr' ? 2 : 1

      if (fileType === 'pdf') {
        window.pdfCapture()
        window.addEventListener('message', (el) => {
          if (captureScreen === 'main') {
            this.MainEditViewProps = {
              imgUrl: el.data.imgBase,
              fileLocation: el.data.currentLocation,
              fileId,
              markType,
            }
            this.showMainEditPhoto = true
          } else {
            this.SplitEditViewProps = {
              imgUrl: el.data.imgBase,
              fileLocation: el.data.currentLocation,
              fileId,
              markType,
            }
            this.showSplitEditPhoto = true
          }
        })
      } else if (fileType === 'svg') {
        const status = await window.svgData[window.location.href].svgCapture()
        if (!status) {
          this.$message.warning('svg未加载完成,请稍候再试！')
          return
        }
        window.addEventListener('message', (el) => {
          if (el.data.type === 'svgCapture') {
            if (captureScreen === 'main') {
              this.MainEditViewProps = {
                imgUrl: el.data.imgBase,
                fileLocation: '',
                fileId,
                markType,
              }
              this.showMainEditPhoto = true
            } else {
              this.SplitEditViewProps = {
                imgUrl: el.data.imgBase,
                fileLocation: '',
                fileId,
                markType,
              }
              this.showSplitEditPhoto = true
            }
          }
        })
      } else if (fileType === 'pr') {
        this.isShowWaitLayer = true // 开启等待图层
        const node = captureScreen === 'main' ? '#EngineVideo' : '#splitScreenEngineVideo'
        const captureDom = document.querySelector(node)
        const imgUrl = await this.getConvertToImage(captureDom)
        const fileLocation = await PlayerUtils.call(
          window.player.Native.CameraAnimation.cameraParam
        )
        if (this.splitFilePrId) {
          fileId = this.splitFilePrId
        } else if (this.$route.query.documentId) {
          fileId = this.temporaryFileId
        }
        if (captureScreen === 'main') {
          this.MainEditViewProps = {
            imgUrl,
            fileLocation,
            fileId,
            markType,
          }
          this.showMainEditPhoto = true
        } else {
          this.SplitEditViewProps = {
            imgUrl,
            fileLocation,
            fileId,
            markType,
          }
          this.showSplitEditPhoto = true
        }
      } else if (this.imgTypeList.includes(fileType)) {
        const captureDom = document.querySelector('#mainImgDom')
        const imgUrl = await this.getConvertToImage(captureDom)
        if (captureScreen === 'main') {
          this.MainEditViewProps = {
            imgUrl,
            fileLocation: '',
            fileId: this.mainFileId,
            markType: fileType === 'pr' ? 2 : 1,
          }
          this.showMainEditPhoto = true
        } else {
          this.SplitEditViewProps = {
            imgUrl,
            fileLocation: '',
            fileId,
            markType: fileType === 'pr' ? 2 : 1,
          }
          this.showMainEditPhoto = true
        }
      }
    },
    hideMainEditView(bol) {
      this.showMainEditPhoto = false
    },
    hideSplitEditView(bol) {
      this.showSplitEditPhoto = false
    },
    /**
     * @description: 显示标记列表
     * @param {*}
     * @return {*}
     */

    async showMarkList(currentScreen) {
      if (currentScreen === 'pr') {
        if (this.splitFilePrId) {
          this.currentFileId = this.splitFilePrId
        } else {
          // 根据documentid获取到fileId
          const res = await DocumentManagementService.getDocumentEdite({
            id: this.$route.query.documentId,
          })
          if (res && res.code === 0 && res.data) {
            this.currentFileId = res.data.documentBaseInfo.defaultFileId
          }
        }
      } else if (currentScreen === 'main') {
        this.currentFileId = this.mainFileId
      } else if (currentScreen === 'split') {
        this.currentFileId = this.fileId
      }
      this.$emit('changeModeByDialog', 'system.markList')
    },
    // 开启小地图
    openMap() {
      this.$emit('changeMap', true)
    },
    loadSplitSvg() {
      this.fileLoading = false
      this.$refs.svgIframe.contentWindow.svgIframeId = 'svgIframe'
      this.$refs.svgIframe.contentWindow.svgFileId = this.fileId
      // 加载完分屏svg
      if (this.code) {
        window.svgData[window.location.href].svgHotTrigger(this.code)
      }
    },
    loadSplitOther() {
      this.fileLoading = false
    },
    setFocusScreen(screen) {
      console.log(screen, 'screensssssss')
      this.focusScreen = screen
      let documentId = ''
      if (screen === 'left') {
        documentId = this.mainDocumentId
      } else {
        documentId = this.fileDocumentId
      }
      this.$emit('changeDocRelational', documentId)
    },
    setHtCodeCenter(data) {
      if (this.mainFileType.toLowerCase() === 'wizdrawing') {
        this.$refs.leftHtFrame.contentWindow.setCenter(data)
      }
      if (this.fileType.toLowerCase() === 'wizdrawing') {
        this.$refs.rightHtFrame.contentWindow.setCenter(data)
      }
    },
    htLoad(url, frame) {
      try {
        this.$refs[`${frame}HtFrame`].contentWindow.init(url)
      } catch (error) {
        setTimeout(() => {
          this.htLoad(url, frame)
        }, 500)
        return
      }
      const $window = this.$refs[`${frame}HtFrame`].contentWindow
      if (frame === 'left') {
        $window.htFileId = this.mainFileId
      } else {
        $window.htFileId = this.fileId
      }
      $window.currentScreen = frame
      if (this.currentEnv.VUE_APP_CURRENT_PROJECT === 'GZ') {
        setTimeout(() => {
          $window.setColorChange()
        }, 500)
        this.htTimer = setInterval(() => {
          $window.setColorChange()
        }, 8000)
      }
    },
    // 初始化节点颜色
    async recoverNodeColor(val) {
      const itemList = []
      if (_.isEmpty(this.progressCodeByItem)) {
        await this.getCodeByItem()
      }
      _.forEach(val, (el) => {
        if (this.progressCodeByItem.hasOwnProperty(el)) {
          itemList.push(this.progressCodeByItem[el])
        }
      })
      this.player.Native.ModelTree.restoreItemColor(itemList)
    },
    // 启用工具栏
    activeTool() {
      this.isDisableTool = false
      // 取消监听
      window.player.Native.ModelTree.EventBrowseLClick.disconnect(this.complexCheck)
    },
    // 禁用工具栏
    forbiddenTool() {
      this.activePlayerTabName = ''
      this.isDisableTool = true
      window.player.Native.Tools.setCurrentTool('system.Browse')
      // 监听点击模型
      window.player.Native.ModelTree.EventBrowseLClick.connect(this.complexCheck)
    },
    // 多选
    async complexCheck(e) {
      if (this.clickModels.indexOf(e.object) === -1) {
        // 获取最近的具有code的节点
        let res = await PlayerUtils.call(window.player.Native.ModelTree.getItemInfo, e.object.item)
        while (res.parentItem && !res.code) {
          res = await PlayerUtils.call(window.player.Native.ModelTree.getItemInfo, res.parentItem)
        }
        this.player.Native.ModelTree.setItemColor(res.code, 0x0000ffff)
        this.clickModels.push(res)
      }
      this.$emit('clickModel', this.clickModels)
    },
    planInit() {
      this.player.Native.ModelTree.getItemByCode(this.allTagData[0], (res) => {
        this.player.Native.ModelTree.setSelectItem(res.item)
        this.player.Native.ModelTree.setItemColor(res.item, 0xff0000ff)
      })
    },
    recoverModel() {
      this.player.Native.ModelTree.restoreAllItemColor()
    },
    // 初始化模型显示
    async initModelVisible() {
      const rootInfos = await PlayerUtils.call(this.player.Native.ModelTree.getRootItems)
      const rootItems = _.map(rootInfos, 'item')
      this.player.Native.ModelTree.setItemVisible(rootItems, true)
    },
    // 处理进度模拟变化的列表
    getChangedList(start, end, data) {
      this.changeProcessMap = new Map()
      for (let i = start; i < end; i = i + 1) {
        const dayData = data[i]
        if (dayData) {
          _.forEach(dayData, (v, k) => {
            const lastList = _.isNil(this.changeProcessMap.get(k))
              ? []
              : this.changeProcessMap.get(k)
            if (_.isNil(v)) {
              this.changeProcessMap.set(k, [])
            } else if (!_.isEmpty(v)) {
              // 判断是否为特殊list
              if (this.processList.indexOf(k) !== -1) {
                const temp = _.uniq([...v, ...lastList])
                this.changeProcessMap.set(k, temp)
              } else {
                this.changeProcessMap.set(k, v)
              }
            } else {
              this.changeProcessMap.set(k, lastList)
            }
          })
        }
      }
    },
    // 通知模型变色
    async sumbitEngineChanges(changeMap) {
      this.flag = false
      const that = this
      for (const item of changeMap.entries()) {
        const key = item[0]
        const value = item[1]
        // 获取item
        const itemList = []
        if (!_.isEmpty(value) && key !== 'norMalNonConstruction' && key !== 'notInDateRange') {
          for (let index = 0; index < value.length; index++) {
            const element = value[index]
            if (that.progressCodeByItem.hasOwnProperty(element)) {
              itemList.push(that.progressCodeByItem[element])
            }
          }
          const flagLength = 4000
          if (itemList.length > flagLength) {
            const loopNum = Math.ceil(itemList.length / flagLength)
            for (let i = 0; i < loopNum; i++) {
              const el = itemList.slice(i * flagLength, (i + 1) * flagLength)
              await this.player.Native.ModelTree.setItemColor(el, this.highlightColorData[key])
            }
          } else {
            await this.player.Native.ModelTree.setItemColor(itemList, this.highlightColorData[key])
          }
        }
      }
      this.flag = true
    },
    // 直接通过code修改模型颜色
    async sumbitEngineChangesByCode(changeArr, color) {
      const itemList = []
      if (_.isEmpty(this.progressCodeByItem)) {
        await this.getCodeByItem()
      }
      _.forEach(changeArr, (el) => {
        if (this.progressCodeByItem.hasOwnProperty(el)) {
          itemList.push(this.progressCodeByItem[el])
        }
      })
      const flagLength = 5000
      if (itemList.length > flagLength) {
        const loopNum = Math.ceil(itemList.length / flagLength)
        for (let i = 0; i < loopNum; i = i + 1) {
          const element = itemList.slice(i * flagLength, (i + 1) * flagLength)
          await this.player.Native.ModelTree.setItemColor(element, color)
        }
      } else {
        await this.player.Native.ModelTree.setItemColor(itemList, color)
      }
    },
    // 提前获取模型code对应的item
    async getCodeByItem() {
      this.progressCodeByItem = {}
      // 获取所有节点缓存
      const genrateCachedItemsByCodeNum = await PlayerUtils.call(
        this.player.Native.ModelTree.genrateCachedItemsByCode
      )
      for (let i = 0; i < Math.ceil(genrateCachedItemsByCodeNum / 1000); i = i + 1) {
        // 分页获取节点和位号
        const res = await PlayerUtils.call(player.Native.ModelTree.getCachedItems, 1000, i)
        if (_.isEmpty(res)) break
        Object.assign(this.progressCodeByItem, res)
      }
    },
    async resetProgress() {
      if (this.player) {
        const modelInfo = await PlayerUtils.call(this.player.Native.Model.getInfo, this.playerId)
        this.player.Native.ModelTree.setItemColor(modelInfo.treeItem, 0xffffff80)
      }
    },
    // 获取子节点
    async getSubItemsByCode(val) {
      const result = []
      for (let i = 0; i < val.length; i = i + 1) {
        const el = val[i]
        // 根据code获取item
        const res = await PlayerUtils.call(this.player.Native.ModelTree.getSubItems, el)
        result.push(...res)
      }
      return result
    },
    // 获取父节点
    async getParentNodeByItem(val) {
      const parentItemList = []
      for (let i = 0; i < val.length; i = i + 1) {
        const element = val[i]
        let parentItem = ''
        let parantInfo = {}
        const res = await PlayerUtils.call(this.player.Native.ModelTree.getItemInfo, element)
        parentItem = _.isEmpty(res) ? '' : res.parentItem
        while (parentItem !== '') {
          parantInfo = await PlayerUtils.call(this.player.Native.ModelTree.getItemInfo, parentItem)
          parentItemList.push(parantInfo)
          parentItem = parantInfo.selfId === 1 ? '' : parantInfo.parentItem
        }
      }
      return parentItemList
    },
    // 视频播放部分
    onPlayerPlay(player) {
      console.log('player', player)
    },
    onPlayerPause(player) {
      console.log('player pause', player)
    },
    playerReadied(player) {
      player.currentTime(0)
    },
    clickModelTree(data) {
      // 单击模型树
      this.player.Native.ModelTree.setSelectItem(data.item)
      this.player.Native.Camera.moveToItem(data.item, 2)
      // 获取关联位号详情
      this.$emit('getTagInfo', {
        data,
        type: 2,
        isFromPlayer: false,
        centerSvg: true,
      })
      this.modelTreeProp.currentNodeItem = data.item // 储存选中节点的item
    },
    closeModelTree() {
      // 关闭模型树
      this.showModelTree = false
      this.activePlayerTabName = ''
      this.modelTreeProp.currentNodeName = ''
    },
    // 获取模型树数据
    async getModelTreeDatas() {
      // 加载模型完成后获取模型数据
      this.modelTreeProp.treeData = await PlayerUtils.call(
        this.player.Native.ModelTree.getRootItems
      )
      // 删除地球GIS层
      this.modelTreeProp.treeData = _.filter(this.modelTreeProp.treeData, (item) => {
        return (
          item.itemType === this.modelTreeObj.ITEM_PR ||
          item.itemType === this.modelTreeObj.ITEM_NODE
        )
      })
      // 构建第一层的name
      _.forEach(this.modelTreeProp.treeData, (result) => {
        let fileNameItem
        switch (result.itemType) {
          case this.modelTreeObj.ITEM_PR:
            fileNameItem = _.find(this.ModelMapList, ['name', result.ownModel])
            break
          case this.modelTreeObj.ITEM_NODE:
            // 节点对应的item
            fileNameItem = _.find(this.ModelMapList, ['name', 'tower'])
            break
        }
        if (fileNameItem) {
          result.name = result.code
            ? `${fileNameItem.fileName}[${result.code}]`
            : fileNameItem.fileName
        }
      })
    },
    // 云渲染tool方法
    async tagsClick(val, tag) {
      let lastActivePlayerTabName = ''
      this.$emit('changeClip', false)
      // 不需要激活态的节点
      const unActiveNode = [
        'system.ToolHideModelSpaceSwap',
        'system.ToolHideModel',
        'system.ToolShowModel',
        'system.ToolShowAll',
      ]
      // 需要打开弹框的节点
      const openDialogNode = [
        'system.roamPathList',
        'system.measurePoint',
        'system.bindMeasurePoint',
        'system.configureManage',
        'system.monitorList',
        'system.personnelPositioning',
        'system.fenceDataList',
        'system.editTexture',
        'system.transparencySetting',
        'system.equipmentInfo',
        'system.alarmInfo',
      ]
      // 测量工具集合
      const measureList = {
        M_None: 0, // 清除测量结果
        M_Line: 1, // 两点测量
        M_Point: 2, // 多点测量
        M_Vertical: 3, // 高度测量
        M_Stereo: 4, // 立体测量
        M_Angel: 5, // 角度测量
        M_Area: 6, // 面积测量
        M_WheelBase: 7, // 轴距测量
      }
      if (this.isDisableTool) {
        this.activePlayerTabName = ''
      } else {
        this.activePickup = false
        lastActivePlayerTabName = this.activePlayerTabName
        if (!unActiveNode.includes(tag.val)) {
          // player头部tab激活状态
          if (this.activePlayerTabName === 'system.walk.fixView') {
            // 释放物理场景
            this.player.Native.PhysicsMgr.releasePhysicsScene()
          }
          this.activePlayerTabName = tag.name === this.activePlayerTabName ? '' : tag.name
        }
        if (val === 'modelTree') {
          this.getModelTreeDatas()
          this.showModelTree = !this.showModelTree
          if (this.showModelTree) {
            // 判断是否有当前是否有选中状态的节点
            const path = await this.player.Native.ModelTree.getSelectedItem()
            if (path) {
              // 获取节点的name
              this.modelTreeProp.currentNodeName = path.name
            }
          }
          return
        }
      }
      if (
        val === 'system.AllClipBox' ||
        val === 'system.PartClipBox' ||
        val === 'system.ThreePanel'
      ) {
        this.setClipBox(lastActivePlayerTabName)
        return
      }
      if (
        lastActivePlayerTabName === '全局剖切' ||
        lastActivePlayerTabName === '局部剖切' ||
        lastActivePlayerTabName === '三面剖切'
      ) {
        cancelClip(this.player)
      }
      if (unActiveNode.includes(val)) {
        this.setModelVisible(val)
        return
      }
      if (openDialogNode.indexOf(val) !== -1) {
        window.player.Native.Tools.setCurrentTool('system.Browse')
        this.$emit('changeModeByDialog', val)
      } else if (val === 'system.markList') {
        this.showMarkList('pr')
      } else if (!this.activePlayerTabName) {
        window.player.Native.Tools.setCurrentTool('system.Browse')
      } else if (val === 'system.PickupCenter') {
        this.code = this.centerCode
        this.moveCameraByCode(this.code)
      } else if (val === 'system.cable') {
        this.showTab = true
        this.leftCom = 'cable'
        this.$emit('openCableMode', true)
      } else if (val === 'system.mark') {
        this.captureImage('pr')
      } else if (val === 'system.process') {
        this.showTab = true
        this.leftCom = 'process'
        this.$emit('changeProcessMode', true)
      } else if (val === 'system.clash') {
        this.showTab = true
        this.leftCom = 'clash'
        this.$emit('changeClashMode', true)
      } else if (val === 'system.walk.fixView') {
        this.walk(val)
      } else if (unActiveNode.indexOf(val) !== -1) {
        this.showTab = false
        // 空间交换
        window.player.Native.Tools.setCurrentTool(val)
      } else if (_.keys(measureList).indexOf(val) !== -1) {
        window.player.Native.Tools.setCurrentTool('system.Browse')
        this.showTab = false
        // 设置测量相关功能
        window.player.Native.ModelMeasure.selectMeasure(measureList[val])
        if (val === 'M_None') {
          // 如果是清除按钮
          window.player.Native.ModelMeasure.clearAllResult()
        }
      } else {
        // 清空测量工具
        window.player.Native.ModelMeasure.selectMeasure(0)
        window.player.Native.ModelMeasure.clearAllResult()
        this.showTab = false
        window.player.Native.Tools.setCurrentTool(val)
      }
      this.checkMarked()
    },
    /**
     * @description: 模型的切换显示
     * @param {*} status 当前状态  显示上一个、隐藏、显示全部、空间交换
     * @param {*} isChecked 是否显示
     * @param {*} selectInfo 当前选中节点信息
     * @return {*}
     */

    // 控制模型中部件的显示隐藏
    async setModelVisible(status, isChecked = true, selectInfo = {}, checkeds) {
      if (_.isEmpty(selectInfo)) {
        // 获取当前点选的对象
        selectInfo = await PlayerUtils.call(this.player.Native.ModelTree.getSelectedItem)
      }
      const itemList = _.map(this.modelHideList, (el) => {
        return el.item
      })
      const rootItems = await PlayerUtils.call(this.player.Native.ModelTree.getRootItems)
      // 删除地球GIS层
      const rootItemsList = _.map(
        _.filter(rootItems, (item) => {
          return (
            item.itemType === this.modelTreeObj.ITEM_PR ||
            item.itemType === this.modelTreeObj.ITEM_NODE
          )
        }),
        (el) => {
          return el.item
        }
      )
      switch (status) {
        case 'system.ToolShowModel':
          // 显示上一个(影藏模型列表弹出最后一个，隐藏最后一个，默认框选中的列表添加弹出的最后一个)
          if (this.modelHideList.length > 0 && !this.spaceSwapStatus) {
            this.player.Native.ModelTree.setItemVisible(
              this.modelHideList[this.modelHideList.length - 1].item,
              isChecked
            )
            this.modelTreeProp.defaultCheckedKey.push(
              this.modelHideList[this.modelHideList.length - 1].item
            )
            this.filterItem.splice(
              this.filterItem.indexOf(this.modelHideList[this.modelHideList.length - 1].item),
              1
            )
            this.modelHideList.pop()
          }
          break
        case 'system.ToolShowAll':
          // 显示全部隐藏（根据上面获取的跟节点之间都设置为true，清空影藏模型列表，默认框选中的列表加上影藏模型列表）
          this.player.Native.ModelTree.setItemVisible(rootItemsList, isChecked)
          // 去重
          this.modelTreeProp.defaultCheckedKey = _.uniq([
            ...this.modelTreeProp.defaultCheckedKey,
            ...this.filterItem,
          ])
          this.filterItem = []
          this.modelHideList = []
          break
        case 'system.ToolHideModel':
          // 隐藏选中节点（把当前要影藏的项添加到影藏模型列表中，设置当前项影藏状态，当前项以及其子孙节点都应该从默认框选中列表中除去）
          this.modelHideList.push(selectInfo)
          this.player.Native.ModelTree.setItemVisible(selectInfo.item, false)
          this.filterItem.push(selectInfo.item)
          // 获取选中的selectInfo的父级selfId
          let parentInfo = await PlayerUtils.call(
            this.player.Native.ModelTree.getItemInfo,
            selectInfo.parentItem
          )
          this.filterItem.push(parentInfo.item)
          // 如果不为最外层包裹层
          if (parentInfo.selfId) {
            while (parentInfo.selfId !== 1) {
              parentInfo = await PlayerUtils.call(
                this.player.Native.ModelTree.getItemInfo,
                parentInfo.parentItem
              )
              this.filterItem.push(parentInfo.item)
            }
          }
          const subItems = await PlayerUtils.call(
            this.player.Native.ModelTree.getSubItems,
            selectInfo.item
          )
          // 去重放在报错之后，多push了几次进去
          this.filterItem = _.uniq([
            ...this.filterItem,
            ..._.map(subItems, (res) => {
              return res.item
            }),
          ])
          this.modelTreeProp.defaultCheckedKey = _.filter(
            this.modelTreeProp.defaultCheckedKey,
            (el) => {
              return this.filterItem.indexOf(el) === -1
            }
          )
          break
        case 'system.ToolHideModelSpaceSwap':
          // 隐藏模型，显示隐藏列表（将默认框选中的列表等于影藏模型列表，上一次影藏的全部显示）
          if (this.spaceSwapStatus) {
            this.modelTreeProp.defaultCheckedKey = _.map(this.modelHideList, (el) => {
              return el.item
            })
          } else {
            this.hiddenNodeKeys = _.map(this.modelHideList, (el) => {
              return el.item
            })
          }
          this.player.Native.ModelTree.setItemVisible(rootItemsList, this.spaceSwapStatus)
          this.player.Native.ModelTree.setItemVisible(itemList, !this.spaceSwapStatus)
          this.spaceSwapStatus = !this.spaceSwapStatus

          this.filterItem = _.filter(this.filterItem, (el) => {
            return this.hiddenNodeKeys.indexOf(el) === -1
          })
          this.filterItem = _.uniq([...this.filterItem, ...this.modelTreeProp.defaultCheckedKey])
          ;[this.modelTreeProp.defaultCheckedKey, this.hiddenNodeKeys] = [
            this.hiddenNodeKeys,
            this.modelTreeProp.defaultCheckedKey,
          ]
          break
        case 'checkModelTree':
          // 模型树显影操作: 1、根据勾选情况设置当前勾选项的显影 2、设置默认框选中列表
          // 3、如果是显示: 查找当前项是否在隐藏列表中，如果有就去掉当前项以及其子孙节点，默认框选中列表中需要添加当前项，如果该项的其他兄弟节点都为选中状态，那么其父辈节点也就要添加进去
          // 4、如果是影藏：将当前项添加到影藏模型列表中去，默认框选中列表除去当前项以及其子孙节点，还包括其父辈节点
          this.player.Native.ModelTree.setItemVisible(selectInfo.item, isChecked)
          this.modelTreeProp.defaultCheckedKey = checkeds.checkedKeys
          if (isChecked) {
            const index = _.findIndex(this.modelHideList, ['item', selectInfo.item])
            if (index !== -1) {
              this.modelHideList.splice(index, 1)
            }
            const index1 = this.filterItem.indexOf(selectInfo.item)
            if (index1 !== -1) {
              // 重新设置选中
              // this.modelTreeProp.defaultCheckedKey.push(selectInfo.item)
              this.filterItem.splice(this.filterItem.indexOf(selectInfo.item), 1)
            }
          } else {
            this.modelHideList.push(selectInfo)
            this.filterItem.push(selectInfo.item)
            // 获取选中的selectInfo的父级selfId
            let parentNodeInfo = await PlayerUtils.call(
              this.player.Native.ModelTree.getItemInfo,
              selectInfo.parentItem
            )
            this.filterItem.push(parentNodeInfo.item)
            if (parentNodeInfo.selfId) {
              // 等于0则为最外面的一层
              while (parentNodeInfo.selfId !== 1) {
                parentNodeInfo = await PlayerUtils.call(
                  this.player.Native.ModelTree.getItemInfo,
                  parentNodeInfo.parentItem
                )
                this.filterItem.push(parentNodeInfo.item)
              }
            }
            this.filterItem = _.uniq(this.filterItem)
          }
          break
        default:
          break
      }
    },
    async checkMarked() {
      // 卸载电缆线
      if (this.showTab) {
        // 去除面板
        const markerList = await PlayerUtils.call(this.player.Native.GisMarker.getMarkerList)
        _.forEach(markerList, (el) => {
          this.player.Native.GisMarker.destroy(el.id)
        })
        const lineList = await PlayerUtils.call(this.player.Native.PathMgr.getAllPath)
        _.forEach(lineList, (el) => {
          this.player.Native.PathMgr.deletePath(el)
        })
        // 清除颜色
        if (this.leftCom !== 'process') {
          await PlayerUtils.call(this.player.Native.ModelTree.restoreAllItemColor)
        }
        this.taryLineId = ''
        this.eMarkedId = ''
        this.sMarkedId = ''
        this.cableInfo = ''
        // 取消选中态
        this.player.Native.ModelTree.setSelectItem(0)
      }
    },
    // 生成uuid
    generateUUID() {
      let d = new Date().getTime()
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now()
      }
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
      })
      return uuid
    },
    async findFileList(documentId) {
      if (!documentId) return
      // 获取文件列表
      const res = await DocumentService.findFileList({
        documentId,
        isUnionObsoletedocument: true,
        standardId: localStorage.getItem('standardId') || '',
      })
      if (res) {
        this.fileList[documentId] = res
      }
    },
    // 根据模型获取对应的模型附件信息
    async getDemPlayerId(playerId) {
      const res = await DocumentService.findFileList({
        documentId: this.$route.query.documentId || this.documentId,
        standardId: localStorage.getItem('standardId') || '',
      })
      if (res.success && res.data) {
        // 获取当前模型的信息
        const playerInfo = _.filter(res.data, (item) => {
          return item.md5 === playerId
        })
        // 根据当前模型的信息找到对应的模型附件信息
        const otherPlayerInfo = _.filter(res.data, (item) => {
          return (
            playerInfo[0] &&
            item.documentName === playerInfo[0].documentName &&
            item.fileType.toLowerCase() === '.demMask'
          )
        })
        this.demPlayerId = otherPlayerInfo[0] ? otherPlayerInfo[0].md5 : ''
      } else {
        this.demPlayerId = ''
      }
    },
    downloadFile(playerId, type) {
      // 没有模型附件就创建下载任务，下载模型附件
      if (type === 'demMask') {
        if (!this.demPlayerId) {
          return
        }
      }
      this.player.Native.File.EventDownloadProcessChanged.connect(this.progressMsg)
      this.player.Native.File.EventDownloadFinish.connect(this.downloadMsg)
      this.player.Native.File.downloadFile(
        `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${playerId}/${playerId}.${type}`,
        'GET',
        `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${playerId}`,
        { Authorization: `${this.fullToken}` },
        (res) => {
          // 代表创建下载任务成功
          if (res) {
            this.showProgress = true
          } else {
            this.$message.warning('下载模型失败')
          }
        }
      )
    },
    // 检查模型并加载
    checkModel() {
      const playerId = this.playerId ? this.playerId : this.splitScreenPlayerId
      if (!playerId) {
        this.$message.error('当前项目没有模型')
        return
      }
      // 检测模型是否存在
      window.player.Native.File.getFileMd5(
        `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${playerId}/${playerId}.pr`,
        (res) => {
          if (res === playerId) {
            // 有模型就加载模型
            if (this.addModelOrNode === -1) {
              this.addModel(
                playerId,
                `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${playerId}/${playerId}.pr`
              )
            } else {
              this.addNode(
                playerId,
                `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${playerId}/${playerId}.pr`
              )
            }
            return
          }
          // 校验md5失败
          this.downloadFile(playerId, 'pr')
        }
      )
    },
    // 加载模型
    async addModel(name, url) {
      // 监听模型加载进度
      window.player.Native.Model.EventProgress.connect(this.checkModelLoad)
      window.player.Native.Model.EventProgressText.connect(this.checkModelLoadText)
      window.player.Native.Model.EventProgressEnd.connect(this.checkModelLoadEnd)
      // 加载模型
      const resList = await PlayerUtils.call(window.player.Native.Model.loadModel, name, url)
      // 加载模型材质文件
      window.player.Native.Model.loadItemMaterial(name)
      if (resList || resList === null) {
        this.$message.error(resList)
        return
      }
      this.loadModel = true
      // 根据模型获取模型附件md5
      await this.getDemPlayerId(name)
      // 加载模型完成后判断远程是否有模型附件，如果有就判断本地有没有该模型附件，
      // 如果没有就下载模型附件，如果有就直接拿到文件然后调用loadDemMaskFile方法，加载地形融合文件，如果远程上没有就不管
      // 检测模型附件是否存在
      window.player.Native.File.getFileMd5(
        `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${name}/${name}.demMask`,
        (res) => {
          if (res && this.demPlayerId && res === this.demPlayerId) {
            // 有模型附件就加载模型
            window.player.Native.Model.loadDemMaskFile(
              name,
              `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${name}/${name}.demMask`
            )
            return
          }
          // 没有就下载模型附件
          this.downloadFile(name, 'demMask')
        }
      )
      // 加载模型完成后获取模型数据
      this.modelTreeProp.treeData = await PlayerUtils.call(
        this.player.Native.ModelTree.getRootItems
      )
      // // 设置小地图的大小
      // window.player.Native.Settings.set('map.size.x', 'int', 280)
      // window.player.Native.Settings.set('map.size.y', 'int', 210)
      // // 设置小地图的位置右下
      // window.player.Native.Settings.set('map.pos', 'int', 3)
      if (this.code) {
        setTimeout(() => {
          this.moveCameraByCode(this.code)
        }, 5000)
      }
      let mat1
      let mat
      if (this.currentProject.latitude && this.currentProject.longitude) {
        // 有地球
        const latitude = this.currentProject.latitude
        const longitude = this.currentProject.longitude
        // 设置地形攀爬
        await PlayerUtils.call(window.player.Native.Model.setModelClampTerrain, name, true)
        const llh = [longitude, latitude, '53'] // 获取经纬度和高度向量
        // 查询经纬度的高程信息,返回的是数组,批量查询结果与单个查询一致，但性能更高
        llh[2] = (await PlayerUtils.call(window.player.Native.GisPlatform.queryDEM, [llh]))[0]
        mat = await PlayerUtils.call(
          window.player.Native.GisPlatform.makeMatrixByLLH,
          llh,
          [0, 0, 0],
          [1, 1, 1]
        ) // 创建基于经纬度、地表面坐标系的旋转、局部坐标系缩放的模型矩阵
        await PlayerUtils.call(window.player.Native.Model.setModelGisPos, name, llh) // 设置模型位置
        await PlayerUtils.call(window.player.Native.Model.setModelClampOffset, name, 0) // 设置地形攀爬偏移量
        llh[2] += 1000
        mat1 = await PlayerUtils.call(
          window.player.Native.GisPlatform.makeMatrixByLLH,
          llh,
          [0, 0, 0],
          [1, 1, 1]
        ) // 创建基于经纬度、地表面坐标系的旋转、局部坐标系缩放的模型矩阵
        // 获取模型信息 srcAabb:模型坐标系包围盒
        const info = await PlayerUtils.call(window.player.Native.Model.getInfo, name)
        await PlayerUtils.call(window.player.Native.Camera.clearMoveTo)
        // 动态区分模型文件
        // if (name == '97618d19b6d17fa337e646542f27b407') {
        //   let param = {
        //     eye: [429386.73069914756, 4468609.616029693, 4517044.25741364],
        //     target: [429379.49875627365, 4468534.353584357, 4516968.179200291],
        //     up: [0.9825277467224242, -0.17030164823372296, 0.07507713053542496],
        //   }
        //   window.player.Native.Camera.moveTo(param.eye, param.target, param.up, 2)
        // } else {
        // 移动相机看向包围盒
        //   PlayerUtils.addMoveToAabb(window.player, info.srcAabb, mat1, [0, 0, 1], [-1, 0, 1], 2)
        // 移动相机看向包围盒
        //   PlayerUtils.addMoveToAabb(window.player, info.srcAabb, mat, [0, 0, 1], [-1, 0, 1], 2)
        // 移动相机看向包围盒
        //   PlayerUtils.addMoveToAabb(window.player, info.srcAabb, mat, [1, -1, 1], [0, 0, 1], 0.5)
        // }
        // 移动相机看向包围盒
        PlayerUtils.addMoveToAabb(window.player, info.srcAabb, mat1, [0, 0, 1], [-1, 0, 1], 2)
        // 移动相机看向包围盒
        PlayerUtils.addMoveToAabb(window.player, info.srcAabb, mat, [0, 0, 1], [-1, 0, 1], 2)
        // 移动相机看向包围盒
        PlayerUtils.addMoveToAabb(window.player, info.srcAabb, mat, [1, -1, 1], [0, 0, 1], 0.5)
        return
      }
      mat = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
      mat1 = mat
      if (this.$route.query.code) {
        // 相机移动到code
        this.moveCameraByCode(this.$route.query.code)
      } else if (this.modelLocationByComponent !== '') {
        this.moveCameraByVector(this.modelLocationByComponent)
      } else if (!_.isNil(this.modelLocation)) {
        // 相机移动到模型默认视角
        this.moveCameraByVector(this.modelLocation)
      } else if (this.leftCom !== 'process') {
        // 当为进度模拟状态时  不改变模型视角
        // 获取模型信息 srcAabb:模型坐标系包围盒
        const info = await PlayerUtils.call(window.player.Native.Model.getInfo, name)
        // 移动相机看向包围盒
        PlayerUtils.moveToAabb(window.player, info.srcAabb, mat, [1, -1, 1], [0, 0, 1], 2)
      }
    },
    async addNode(name, url) {
      // 加载节点文件
      const res = await PlayerUtils.call(
        this.player.Native.NodeProxy.loadNode,
        url,
        `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${name}`,
        `${name}.pr`,
        ''
      )
      console.log(res)
      this.modelTreeProp.treeData = await PlayerUtils.call(
        this.player.Native.ModelTree.getRootItems
      )
      this.player.Native.Camera.moveToItem(this.modelTreeProp.treeData[0].item, 2)
      this.$emit('loaded', true)
    },
    /**
     * @description: 监听模型加载进度
     * @param {*} data
     * @return {*}
     */

    checkModelLoad(data) {
      this.showLoadProgress = true
      this.loadPercentage = data * 100
    },
    /**
     * @description: 监听模型加载进度文字
     * @param {*} data
     * @return {*}
     */
    checkModelLoadText(data) {
      this.loadPercentageText = data
    },
    /**
     * @description: 监听模型加载完成
     * @param {*} data
     * @return {*}
     */
    checkModelLoadEnd() {
      this.showLoadProgress = false
      window.player.Native.Model.EventProgress.disconnect(this.checkModelLoad)
      window.player.Native.Model.EventProgressText.disconnect(this.checkModelLoadText)
      window.player.Native.Model.EventProgressEnd.disconnect(this.checkModelLoadEnd)
    },
    // 监听下载进度
    progressMsg(file, bytesReceived, bytesTotal) {
      if (bytesTotal) {
        this.percentage = parseInt((bytesReceived / bytesTotal) * 100, 10)
      }
    },
    // 监听下载模型是否成功
    downloadMsg(file, err) {
      if (err) {
        this.$message.warning(`下载文件失败，${file}, ${err}`)
      }
      this.showProgress = false
      if (
        file ===
        `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${this.playerId}/${this.playerId}.pr`
      ) {
        // 检查当前md5和远程下载的md5是否一致
        window.player.Native.File.getFileMd5(
          `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${this.playerId}/${this.playerId}.pr`,
          (res) => {
            if (res !== this.playerId) {
              this.$message.warning('当前请求的md5和服务器下载的md5不一致！')
            }
          }
        )
        if (this.addModelOrNode === -1) {
          this.addModel(this.playerId, file, '', '') // 模型下载成功就加载模型
        } else {
          this.addNode(this.playerId, file)
        }
      }
      if (
        file ===
        `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${this.playerId}/${this.playerId}.demMask`
      ) {
        // 有模型附件就调用地形融合方法
        window.player.Native.Model.loadDemMaskFile(
          this.playerId,
          `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/models/${this.playerId}/${this.playerId}.demMask`
        )
      }
      this.player.Native.File.EventDownloadFinish.disconnect(this.downloadMsg) // 断开下载
      this.player.Native.File.EventDownloadProcessChanged.disconnect(this.progressMsg)
    },
    runPlayer(videoDom) {
      this.fullscreenLoading = true
      const uuid = this.generateUUID() // 生成唯一的引擎id
      if (this.player) {
        this.player.exit()
      }
      const cloundServerPath = `${Wiz.globalSettings.globalConfig.modelSetting.cloudProtocol}://${Wiz.globalSettings.globalConfig.modelSetting.cloudServerPath}`
      // 创建RemotePlayer对象
      this.player = new RemotePlayer({
        video: document.getElementById(videoDom), // 绑定视频标签
        signalServer: cloundServerPath, // 信令服务器地址(player给提供都是ws)
        engineId: uuid, // 要连接的引擎ID
        autoResize: true, // 引擎是否跟时评标签尺寸
        userTimeout: 1000 * 60 * 30, // 用户操作超时设置，毫秒 1800000
        exitTimeout: 1000 * 60 * 1, // 用户超时后多久断开会话 1000 * 60 * 1
        // debug: true,
      })
      // 监听实例化完成后
      this.player.on('NativeLoad', () => {
        if (this.currentEnv.VUE_APP_CURRENT_PROJECT === 'HY') {
          // 默认显示小地图
          this.$emit('changeMap', true, 'model')
        }
        // 设置点选时其他节点半透明
        this.player.Native.Settings.set('color.pickup.bkAlpha', 'float', '0.5')
        // 获取到经纬度添加地图/*  */
        if (this.currentProject.latitude && this.currentProject.longitude) {
          this.player.Native.GisPlatform.loadMap(this.globalMapPath, () => {})
        }
        this.preferenceSettings()
        //  GIS模式下浏览时，设置启用/禁用摄像机地形碰撞,默认为启用状态 摄像机可进入到地形之下
        this.player.Native.GisPlatform.setCameraTerrainCollisionEnabled(false)
        this.fullscreenLoading = false
        this.fileLoading = false
        window.player = this.player
        // 模型上的点选事件
        window.player.Native.ModelTree.EventSelectItemChanged.connect(this.watchMsg)
        this.player.Native.Model.getAllInfo((res) => {
          // 获取所有模型，判断是否为空，在做对应的操作
          if (!_.isEmpty(res)) {
            _.forIn(res, (key, item) => {
              // 如果有模型存在，卸载所有模型
              this.player.Native.Model.unloadModel(item)
            })
          }
          this.checkModel()
        })
      })
      // 循环检测页面操作情况，如果超过一段时间没有操作就提示登录超时，并关闭页面
      this.player.on('UserTimeOut', () => {
        if (this.$route.path === '/docView') {
          this.$confirm('非常抱歉，由于您长时间未操作系统，系统已自动终止!', '警告提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              window.player.resetTimer()
            })
            .catch(() => {
              // 取消操作时，重新计算时间
              window.player.resetTimer()
            })
        }
      })
      // 监听引擎断开，跟UserTimeOut不同之处是，这个是已经退出的消息，不能取消
      this.player.on('TimeOutExit', () => {
        this.$message({
          message: '连接已经断开',
          type: 'warning',
        })
      })
    },
    async preferenceSettings() {
      const jsonData = await this.player.Native.Settings.loadJsonString(
        `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/settings.json`
      )
      if (jsonData) {
        this.defaultSettings = JSON.parse(jsonData)
        this.setPreferenceSettings()
      } else {
        this.defaultSettings.Show = await this.player.Native.Settings.getAll()
        this.defaultSettings.RoamTrance = await this.player.Native.Walking.getHotkeys()
        this.defaultSettings.Skin = {
          avatarCapSkin: 'helmet_white.jpg',
          avatarBodySkin: 'GongRen_red.jpg',
        }
      }
      // 获取用户偏好
      // this.getPreferenceSettings()
    },
    /**
     * @description: 获取用户偏好设置
     * @param {*} null
     * @return {*}
     */
    async getPreferenceSettings() {
      const res = await PreferenceSettings.getPreferenceSetting()
      if (res && res.code === 0 && res.data) {
        this.userPreferenceSettings = res.data
        this.setPreferenceSettings()
      }
    },
    /**
     * @description: 设置用户偏好设置
     * @param {*} null
     * @return {*}
     */
    async setPreferenceSettings() {
      if (this.userPreferenceSettings.Show) {
        const showSettings = await this.player.Native.Settings.getAll()
        _.forIn(this.userPreferenceSettings.Show, (value, key) => {
          const settingInfo = _.find(showSettings, ['name', key])
          if (settingInfo) {
            let currentValue = ''
            if (settingInfo.type === 'bool') {
              currentValue = value === 'true' || value === true
            } else if (
              settingInfo.type === 'int' ||
              settingInfo.type === 'float' ||
              settingInfo.type === 'double'
            ) {
              currentValue = _.toNumber(value)
            } else {
              currentValue = value
            }
            this.player.Native.Settings.set(key, settingInfo.type, currentValue)
          }
        })
      } else if (this.defaultSettings.Show) {
        _.forEach(this.defaultSettings.Show, (item) => {
          this.player.Native.Settings.set(item.name, item.type, item.value)
        })
      }
      const roamingSettings = this.userPreferenceSettings.RoamTrance
        ? this.userPreferenceSettings.RoamTrance
        : this.defaultSettings.RoamTrance
      _.forIn(roamingSettings, (value, key) => {
        let settingKeys = []
        if (this.userPreferenceSettings.RoamTrance) {
          settingKeys = _.reduce(
            JSON.parse(value),
            (arr, item) => {
              arr.push(item.split('+'))
              return arr
            },
            []
          )
        } else {
          settingKeys = _.reduce(
            value,
            (arr, item) => {
              arr.push(item.split('+'))
              return arr
            },
            []
          )
        }
        this.player.Native.Walking.setHotkey(key, settingKeys)
      })
      const RoamingSpeed = roamingSettings.RoamingSpeed || 1
      this.player.Native.Walking.setAvatarMoveSpeed(RoamingSpeed)
      const figureSettings = this.userPreferenceSettings.People
        ? this.userPreferenceSettings.People
        : this.defaultSettings.Skin
      const isExists = await this.player.Native.File.exists(
        `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/skin`
      )
      if (isExists) {
        this.player.Native.Walking.setAvatarBodySkin(
          `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/skin/${figureSettings.avatarBodySkin}`
        )
        this.player.Native.Walking.setAvatarCapSkin(
          `data://../apps/${this.currentEnv.VUE_APP_CURRENT_PROJECT}/skin/${figureSettings.avatarCapSkin}`
        )
      }
    },
    // 监听点击模型设备获取设备code码
    async watchMsg(data) {
      // 获取设备详细信息
      this.$emit('getTagInfo', {
        data,
        type: 1,
      })
      this.$emit('clickModel', [data])
      if (data && data.code) {
        if (this.mainFileType.toLowerCase() === 'svg' || this.fileType.toLowerCase() === 'svg') {
          window.svgData[window.location.href].svgHotTrigger(data.code)
        }
        this.centerCode = data.code
        if (this.activePlayerTabName === '电缆') {
          this.$emit('getCableData', data)
        }
        // 点选触发模型树定位
        if (this.showModelTree) {
          // 获取选中模型节点的name
          this.modelTreeProp.currentNodeName = data ? data.name : ''
        }
        if (this.activePlayerTabName === '局部剖切') {
          const clipData = await cilpSetting(this.player, this.playerId, false, true, 'box', 4)
          this.axisObjs = clipData.axisObjs
          this.clipObj = clipData.clipObj
        }
      }
    },
    /**
     *  移动摄像机的位置
     * 默认不摆正视角,face值为视角
     */
    async moveCameraByCode(code, face = 0) {
      const query = {
        aabb: {
          min: [0, 0, 0],
          max: [0, 0, 0],
        },
        mat: {},
        face, // 视角
        kDistance: 1.1, // 与包围盒中心的距离系数
        second: 2,
      }
      /**
       * 设置是否需要摆正视角
       * 有地球时，不需要摆正
       */
      if (this.currentProject.latitude !== '' && this.currentProject.longitude !== '') {
        /**
         * Top = 1
         * Bottom = 2
         * Front = 4
         * Back = 8
         * Left = 18
         * Right = 32
         */
        query.face = 0 // 不改变视角
      }
      //  获取模型包围盒信息
      if (code && code.includes(',')) {
        const temp = code.split(',')
        const arr = [] // 锚点位置
        _.forEach(temp, (el, index) => {
          arr[index] = Number(el.split(':')[1].replace(/[^0-9\-.]/gi, '')) / 1000.0
        })
        // 计算锚点包围盒
        query.aabb = {
          min: [arr[0] - 1, arr[1] - 1, arr[2] - 1],
          max: [arr[0] + 1, arr[1] + 1, arr[2] + 1],
        }
        // 获取模型所在的坐标系
        const res = await PlayerUtils.call(
          this.player.Native.Model.getModelGlobalMatrix,
          this.playerId
        )
        query.mat = res
      } else {
        const res = await PlayerUtils.call(this.player.Native.ModelTree.calcItemAabb, code)
        query.aabb = res.localAabb
        query.mat = res.localMatrix
      }
      this.player.Native.Camera.moveToAabb(
        query.aabb,
        query.mat,
        query.face,
        query.kDistance,
        query.second
      )
      const itemInfo = await PlayerUtils.call(this.player.Native.ModelTree.getItemByCode, code)
      this.player.Native.ModelTree.setSelectItem(itemInfo.item)
    },
    // 根据世界向量移动相机
    async moveCameraByVector(val) {
      const info = JSON.parse(val)
      this.player.Native.Camera.moveTo(info.eye, info.target, info.up, 2)
    },
    // 绘制电缆面板准备工作
    async startDrawPanel(val) {
      if (!this.loadModel) return
      if (_.isNil(JSON.parse(val))) {
        // 去除面板
        const markerList = await PlayerUtils.call(this.player.Native.GisMarker.getMarkerList)
        _.forEach(markerList, (el) => {
          this.player.Native.GisMarker.destroy(el.id)
        })
        this.sMarkedId = null
        this.eMarkedId = null
        // 取消选中态
        this.player.Native.ModelTree.setSelectItem(0)
        return
      }
      // 清除之前所有的颜色
      await PlayerUtils.call(this.player.Native.ModelTree.restoreAllItemColor)
      // 设置面板text值
      const info = JSON.parse(val)
      this.player.Native.ModelTree.setItemColor([info.sCode], 0xff0000ff)
      this.player.Native.ModelTree.setItemColor([info.eCode], 0x0000ffff)
      const eText = `\n${info.cableCode}\n\n终点设备：${info.endComponent}\n`
      const sText = `\n${info.cableCode}\n\n起点设备：${info.startComponent}\n`
      const sPos = [] // 起点定位点
      const ePos = [] // 终点定位点
      // 1.加载图片
      if (!this.cableImgId) {
        this.cableImgId = await PlayerUtils.call(
          this.player.Native.GisMarker.loadImage,
          'rgba:174, 165, 224, 255'
        )
      }
      // 2.获取父容器坐标点/*  */
      const resStart = await PlayerUtils.call(this.player.Native.ModelTree.calcItemAabb, info.sCode)
      // 面板定位在包围盒的左前上方
      if (!_.isEmpty(resStart)) {
        sPos[0] = resStart.localAabb.min[0] // x坐标
        sPos[1] = resStart.localAabb.min[1] // y坐标
        sPos[2] = resStart.localAabb.max[2] // z坐标
        if (this.sMarkedId) {
          this.player.Native.GisMarker.update(this.sMarkedId, {
            text: sText,
            pos: sPos,
            imgId: this.cableImgId,
          })
        } else {
          this.drawPanel(sPos, sText, 'start')
        }
      }
      const resEnd = await PlayerUtils.call(this.player.Native.ModelTree.calcItemAabb, info.eCode)
      // 面板定位在包围盒的左前上方
      if (!_.isEmpty(resEnd)) {
        ePos[0] = resEnd.localAabb.min[0] // x坐标
        ePos[1] = resEnd.localAabb.min[1] // y坐标
        ePos[2] = resEnd.localAabb.max[2] // z坐标
        if (this.eMarkedId) {
          this.player.Native.GisMarker.update(this.eMarkedId, {
            text: eText,
            pos: ePos,
            imgId: this.cableImgId,
          })
        } else {
          this.drawPanel(ePos, eText, 'end')
        }
      }
      // 去除多余的面板
      const markerList = await PlayerUtils.call(this.player.Native.GisMarker.getMarkerList)
      _.forEach(markerList, (el) => {
        if (el.id !== this.sMarkedId && el.id !== this.eMarkedId) {
          this.player.Native.GisMarker.destroy(el.id)
        }
      })
    },
    // 绘制面板
    drawPanel(pos, text, stauts) {
      const option = {
        pos, // 定位点，世界坐标，三维向量
        visible: true, // 显示隐藏状态
        size: [250, 90], // 整体尺寸，二维向量，-1表示不限制，自动大小
        nodeOffset: [0, 0], // 相对定位点的偏移量，二维向量
        imgId: this.cableImgId, // 图片
        imgSize: [250, 90], // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
        imgOffset: [0, 0], // 图片相对标记的偏移量
        text, // 文本
        fontSize: 14.0, // 字体大小
        breakWidth: 250, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
        textOffset: [0, 0], // 文字相对标记的偏移量
        textColor: 0xffffffff, // 文本颜色
        title: '', // 标题
        titleFontSize: 18.0, // 标题文字大小
        titleColor: 0xffffffff, // 标题颜色
        userData: null, // 用户数据，仅帮外部系统保存数据
      }
      // option里面的类容均为可选，但是option至少是{}，不能为null
      this.player.Native.GisMarker.create(option, (markerId) => {
        if (stauts === 'start') {
          this.sMarkedId = markerId
        } else {
          this.eMarkedId = markerId
        }
      })
    },
    // 电缆描线
    async startDrawLine(val) {
      if (!this.loadModel) return
      if (_.isNil(JSON.parse(val))) {
        // 判断是否已有线路
        if (this.taryLineId) {
          await PlayerUtils.call(this.player.Native.PathMgr.deletePath, this.taryLineId)
          this.taryLineId = null
        }
        return
      }
      const info = JSON.parse(val)
      const modelInfo = await PlayerUtils.call(this.player.Native.Model.getInfo, this.playerId)
      // 判断是否已有线路
      if (this.taryLineId) {
        await PlayerUtils.call(this.player.Native.PathMgr.deletePath, this.taryLineId)
        this.taryLineId = null
      }
      // 获取电缆编号
      const taryCode = info.cableCode
      // 根据code获取点
      const instancePath = await PlayerUtils.call(
        this.player.Native.Model.getInstancePathByCode,
        this.playerId,
        taryCode
      )
      // 绘制线路的id
      this.taryLineId = await PlayerUtils.call(
        this.player.Native.PathMgr.createPath,
        modelInfo.nodePtr
      )
      // 设置线的颜色
      await PlayerUtils.call(this.player.Native.PathMgr.setDefaultLineColor, 0xff0000ff)
      // 添加点
      await PlayerUtils.call(
        this.player.Native.PathMgr.addPathPoints,
        this.taryLineId,
        instancePath
      )
      // 设置线的粗细
      await PlayerUtils.call(this.player.Native.PathMgr.setPathWidth, this.taryLineId, 3)
      // 通知路径应用修改
      PlayerUtils.call(this.player.Native.PathMgr.submitPathChange, this.taryLineId)
      // 电缆经过的桥架变色
      const cableTrayList = info.cableTray.split(';')
      this.player.Native.ModelTree.setItemColor(cableTrayList, 0x00ff00ff)
      // 定位到电缆
      const { localAabb, localMatrix } = await PlayerUtils.call(
        this.player.Native.ModelTree.calcItemAabb,
        info.cableCode
      )
      if (localAabb && localMatrix) {
        this.player.Native.Camera.moveToAabb(localAabb, localMatrix, 0, 1.1, 2)
      }
    },
    /**
     * 碰撞定位锚点
     */
    async startDrawPoint(val) {
      const info = JSON.parse(val)
      const temp = info.coordinate.split(',')
      const arr = []
      // 清除之前所有的颜色
      await PlayerUtils.call(this.player.Native.ModelTree.restoreAllItemColor)

      this.player.Native.ModelTree.setItemColor([info.tagA.tagCode, info.tagB.tagCode], 0xbf09ecff)
      _.forEach(temp, (el, index) => {
        arr[index] = Number(el.split(':')[1].replace(/[^0-9\-.]/gi, '')) / 1000.0
      })
      // 检查是否有已知的标记
      const markerList = await PlayerUtils.call(this.player.Native.GisMarker.getMarkerList)
      if (markerList.length > 0) {
        this.updatePoint(arr, markerList[0].id)
      } else {
        this.drawPoint(arr)
      }
      // 定位到锚点
      this.codeList = [info.tagA.tagCode]
      this.moveCameraByCode(info.coordinate)
    },
    // 绘制锚点
    async drawPoint(pos) {
      // 加载锚点
      const imgId = await PlayerUtils.call(
        this.player.Native.GisMarker.loadImage,
        'data://icon/qietu/point.png'
      )
      const option = {
        pos, // 定位点，世界坐标，三维向量
        visible: true, // 显示隐藏状态
        size: [20, 20], // 整体尺寸，二维向量，-1表示不限制，自动大小
        nodeOffset: [-10, -10], // 相对定位点的偏移量，二维向量
        imgId, // 图片
        imgSize: [20, 20], // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
        imgOffset: [0, 0], // 图片相对标记的偏移量
        text: '', // 文本
        fontSize: 14.0, // 字体大小
        breakWidth: 250, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
        textOffset: [0, 0], // 文字相对标记的偏移量
        textColor: 0xffffffff, // 文本颜色
        title: '', // 标题
        titleFontSize: 18.0, // 标题文字大小
        titleColor: 0xffffffff, // 标题颜色
        userData: null, // 用户数据，仅帮外部系统保存数据
      }
      this.player.Native.GisMarker.create(option)
    },
    // 更新锚点
    updatePoint(pos, markerId) {
      const option = {
        pos, // 定位点，世界坐标，三维向量
      }
      this.player.Native.GisMarker.update(markerId, option)
    },
    /**
     * 人物漫游
     * type：漫游方式
     */
    walk(type) {
      /**
       * 指定漫游重力方向
       * 0: x, 1: y, 2: z
       */
      this.player.Native.PhysicsMgr.walkAxis(2)
      // 更新物理场景
      this.player.Native.PhysicsMgr.updatePhysicsScene()
      this.player.Native.Tools.setCurrentTool(type)
    },
    /**
     * @description: 全局剖切 / 局部剖切/三面剖切
     * @param {*}
     * @return {*}
     */

    async setClipBox(lastActivePlayerTabName) {
      cancelClip(this.player)
      if (!this.activePlayerTabName) return
      let clipData = {}
      switch (this.activePlayerTabName) {
        case '全局剖切':
          clipData = await cilpSetting(this.player, this.playerId, false, false, 'box', 4)
          this.$emit('changeClip', true, clipData)
          break
        case '局部剖切':
          clipData = await cilpSetting(this.player, this.playerId, false, true, 'box', 4)
          break
        case '三面剖切':
          clipData = await cilpSetting(this.player, this.playerId, true, false, 'ThreePanel', 1)
          break
        default:
          break
      }
      this.axisObjs = clipData.axisObjs
      this.clipObj = clipData.clipObj
    },
    async changeFile(type, location) {
      const currentDocumentId = location === 'main' ? this.mainDocumentId : this.fileDocumentId
      const currentFileId = location === 'main' ? this.mainFileId : this.fileId
      if (!this.fileList[currentDocumentId]) {
        await this.findFileList(currentDocumentId)
      }
      const currentIndex = _.findIndex(this.fileList[currentDocumentId], ['fileId', currentFileId])
      if (currentIndex === this.fileList[currentDocumentId].length - 1 && type === 'next') {
        this.$message({
          message: '已到最后一项',
          type: 'warning',
        })
        return
      }
      if (currentIndex === 0 && type === 'back') {
        this.$message({
          message: '已到第一项',
          type: 'warning',
        })
        return
      }
      const changeFileItem =
        type === 'next'
          ? this.fileList[currentDocumentId][currentIndex + 1]
          : this.fileList[currentDocumentId][currentIndex - 1]
      if (location === 'main') {
        this.mainScreenFileName = changeFileItem.fileName
        this.mainFileType = changeFileItem.fileName.split('.')[1]
        this.mainFileId = changeFileItem.fileId
        this.mainResourceUrl = `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${changeFileItem.md5}`
      } else {
        this.splitScreenFileName = changeFileItem.fileName
        this.fileType = changeFileItem.fileName.split('.')[1]
        this.fileId = changeFileItem.fileId
        this.drawUrl = `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${changeFileItem.md5}`
      }
    },
  },
}
</script>
<style lang="scss" scoped>

/deep/.el-card__body {
  padding: 0 !important;
  width: 100%;
  height: 100%;
  position: relative !important;
}
.captureBut {
  position: fixed;
  top: 10px;
}
.split-box {
  border: 3px solid transparent;
  &:hover {
    border-color: #409eff;
  }
}
.screen-active {
  border-color: #409eff;
}
// #svgIframe #mainSvgIframe {
//   background: #000;
// }父
.player-box {
  position: relative;
  .player-tool {
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.76);
    width: 100%;
    overflow-x: auto;
    height: 44px;
    .tool-tag {
      display: flex;
      align-items: center;
      .model-file-name {
        white-space: nowrap;
      }
      .el-tag {
        flex-shrink: 0;
        margin: 0px 5px;
        background-color: transparent;
        border: 1px solid #ccc !important;
        border: 0px;
        display: flex !important;
        align-items: center;
        &:hover,
        &.active-tab-name {
          border: 1px solid #409eff !important;
          background-color: #eee;
        }
      }
    }
  }
}
.propress-bar {
  position: absolute;
  z-index: 99;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(51, 51, 51, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
}
.model-tree {
  top: 44px;
  width: 450px;
  height: 500px;
  left: 0;
  z-index: 990;
  /deep/.el-tree {
    height: calc(100% - 90px);
    overflow-y: auto;
  }
}
.fileTitle-box {
  // position: absolute;
  // top: 0;
  // background-color: #fff;
  border: 1px solid #ddd;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.show-video {
  position: relative;
  top: 0px;
  left: 0px;
  .video-player {
    height: 85vh !important;
    background: black;
  }
  /deep/.video-js {
    position: relative;
    top: 0;
    left: 0;
    height: 85vh;
    .vjs-big-play-button {
      top: 50% !important;
      left: 50% !important;
      margin-left: -43px;
      margin-top: -21px;
      border: none !important;
    }
    /deep/.vjs-control-bar {
      z-index: 999;
      bottom: 18px !important;
    }
  }
  /deep/.vjs-fluid {
    padding-top: 0 !important;
  }
}
/deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  color: red !important;
}
/deep/ .el-loading-mask {
  background: #409eff !important;
}
.special-tool {
  align-items: center;
}
.mark_btn {
  width: 20px;
  height: 20px;
}
#mainImgDom,
#splitImgDom {
  position: relative;
  overflow: hidden;
  img {
    max-height: 100%;
  }
}
.wait_layer {
  position: absolute;
  background-color: transparent;
  z-index: 2002;
}
.next_file_btn {
  right: 30px;
  bottom: 10px;
  color: #1890ff;
  cursor: pointer;
}
.last_file_btn {
  left: 10px;
  bottom: 10px;
  color: #1890ff;
  cursor: pointer;
}
.position-absolute {
  position: absolute;
}
.position-relative {
  position: relative;
}
.flex-row-center-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
